// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-26T14:38:08.832Z
// Property: Rise (ID: 6767906449167739)
// Collections: 149 amenities, 37 floorplans (live), 59 photos, 77 POIs, 60 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167739",
  "property_external_id": "v90efmg",
  "property_zillow_url": "https://www.zillow.com/apartments/atlanta-ga/ascent-midtown/CjrV6n/",
  "property_apartments_url": "https://www.apartments.com/ascent-midtown-atlanta-ga/v90efmg/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "rise",
  "property_name": "Rise",
  "property_website_url": "http://the-rise-demo-site.multiscreensite.com",
  "property_domain": null,
  "property_address": "100 Peachtree St",
  "property_full_address": "100 Peachtree St, Atlanta, GA 30309",
  "property_address_1": "100 Peachtree St",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30309",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Midtown Atlanta",
  "property_address_latitude": "33.7928053",
  "property_address_longitude": "-84.3880843",
  "property_email": null,
  "property_phone": "123-456-7890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Elevate everyday living</strong> in an upscale, modern high-rise with iconic architecture, extraordinary residences, and walkable access to Atlanta’s urban energy.</p>",
  "property_long_description": "<p>It looks good from up here. Rise is for those who seek an urban oasis at a world-renowned metropolitan address. To revel in a life well-lived with iconic architectural design and best in class resident amenities. Rise offers an unparalleled living experience with walkable access to top employers, exciting city experiences and a central location convenient to the greater Atlanta metropolitan area. Live in an upscale, modern high-rise with iconic architecture, best-in-class amenities and extraordinary residences designed to suit your lifestyle and interests. Elevate your life when you choose Rise. Modern. Stunning. Brilliant.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-11b4-7643-aec9-0c1dcc4a3863.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop seating area with city skyline view.",
    "public_id": "01a03e5d-11b4-7643-aec9-0c1dcc4a3863",
    "storage_key": "property/6767906449167739/01a03e5d-11b4-7643-aec9-0c1dcc4a3863.webp",
    "width": 2048,
    "height": 1366
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "83",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.85365853658537",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "750",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "35",
  "property_pet_restrictions": "Dogs allowed (35 lb weight limit, maximum 2 pets). Cats allowed (maximum 2 pets).",
  "property_pet_policy_description": "Dogs allowed (35 lb weight limit, maximum 2 pets). Cats allowed (maximum 2 pets). Pet fee: One pet $500; two pets $750. Monthly pet rent: $20 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-5b92-70f0-9d9d-ad423441dc8e.webp",
  "property_primary_logo_media": {
    "alt_text": "RISE logo",
    "public_id": "01a03e59-5b92-70f0-9d9d-ad423441dc8e",
    "storage_key": "property/6767906449167739/01a03e59-5b92-70f0-9d9d-ad423441dc8e.webp",
    "width": 1920,
    "height": 1080
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-ac74-744b-aef1-e87c255f628c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-ac74-744b-aef1-e87c255f628c",
    "storage_key": "property/6767906449167739/01a03e5a-ac74-744b-aef1-e87c255f628c.webp",
    "width": 1280,
    "height": 720
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-a036-765a-9486-adc1e3fca7af.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03e5a-a036-765a-9486-adc1e3fca7af",
    "storage_key": "property/6767906449167739/01a03e5a-a036-765a-9486-adc1e3fca7af.webp",
    "width": 1280,
    "height": 720
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#749ed3",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "610 - 1,459 sq ft",
  "property_sqft_min": "610",
  "property_sqft_max": "1,459",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 30,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzzedY1AE9YgRfqVwP3IXcrY",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rise",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>High-rise amenities with Atlanta energy.</strong> Start with a Peloton ride in the expansive fitness center, settle into the clubhouse or study lounge, then head to the 7th-floor terrace for a saltwater pool, cabanas, grills, and open-air seating. Upstairs, the 28th-floor resident lounge frames skyline views, while concierge service, EV charging, covered parking, package lockers, and polished apartment finishes keep every detail elevated.</p>",
  "property_home_floorplans_blurb": "<p><strong>High-rise layouts with room to rise.</strong> From efficient studios to penthouses with upgraded finishes, Rise pairs open floor plans, tall ceilings, and natural light with polished details like chef-caliber kitchens, quartz countertops, walk-in closets, in-home laundry, solar shades, and framed glass balconies in select residences.</p>",
  "property_home_gallery_blurb": "<p><strong>See Rise from every angle.</strong> Browse light-filled interiors with quartz-counter kitchens, sleek cabinetry, wood-style flooring, spa-inspired baths, and city views from select glass balconies. Then preview the 7th-floor terrace with saltwater pool and cabanas, outdoor kitchen, Peloton-equipped fitness center, and 28th-floor lounge with Midtown Atlanta as the backdrop.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Midtown moves right outside Rise.</strong> Start with coffee before MARTA, grab lunch near Tech Square, linger over dinner on Peachtree, or head to the Arts District for galleries, performances, and museum nights. Colony Square, Piedmont Park, Midtown Station, bike lanes, and BeltLine connections keep everyday plans easy to map. Explore nearby patios, parks, markets, and commute stops—then schedule a tour to see the location in motion.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents and visitors keep calling out the Rise experience.</strong> Reviews highlight polished Midtown Atlanta apartments with stunning views, spacious chic layouts, modern finishes, and quick, reliable maintenance.</p><p>Just as often, the leasing team earns praise by name—Diego, Ebony, Taye, and Tameka—for welcoming service, clear answers, and a personal touch. Read the reviews for a closer look at the comfort and care people notice at Rise.</p>",
  "property_neighborhood_blurb": "<p><strong>Step into Midtown’s street-level rhythm.</strong> Around Rise, the neighborhood is less a checklist and more a daily mix: coffee before MARTA, lunch near Tech Square, dinner along Peachtree, and a show or museum night in Atlanta’s Arts District. Walk toward Colony Square for open-air dining and events, browse the galleries and performance venues around Woodruff, or trade city buzz for the lawns and trails of Piedmont Park. Midtown Station keeps Red and Gold Line access close, while bike lanes, pocket parks, and the Atlanta BeltLine make it easy to widen your route without leaving the center of the city. Use the map below to find your next favorite patio, park, market, or commute stop—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Rise connects it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, elevated from morning to night.</strong> At Rise in Midtown Atlanta, your routine can move from a Peloton ride in the expansive fitness center to coffee in the clubhouse, a focused session in the business or study lounge, and an evening on the 7th-floor terrace with a saltwater pool, custom cabanas, grills, and open-air seating.</p><p>Above it all, the 28th-floor resident lounge brings skyline views into everyday downtime, while 24-hour concierge service, controlled access, Amazon package lockers, EV charging, covered garage parking, and high-speed elevators keep the practical details seamless. At home, chef-caliber kitchens, gas cooking, quartz countertops, in-home laundry, solar shades, keyless locks, walk-in closets, and select framed-glass balconies add polish where it matters most. Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Elevate your everyday at Ascent Midtown.</strong> Apply online today for an upscale, modern high-rise experience with iconic architecture, extraordinary residences, and best-in-class amenities—all in a central Midtown location with walkable access to top employers and exciting city experiences.</p>",
  "property_contactus_blurb": "<p><strong>Connect with our leasing team.</strong> Have questions or need directions? Reach out to learn more about this upscale Midtown high-rise, from extraordinary residences and iconic architecture to its central, walkable Atlanta location. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Ascent Midtown?</strong> Start here for quick answers on the community, leasing, amenities, and everyday living in this upscale Midtown high-rise. If you need more detail, the leasing team is happy to help you explore what makes life here sophisticated, modern, and brilliantly connected.</p>",
  "property_floorplans_blurb": "<p><strong>Find your fit above Midtown Atlanta.</strong> Rise offers studio, one-bedroom, two-bedroom, and penthouse floor plans shaped for modern high-rise living, with open layouts, tall ceilings, and natural light that make each residence feel polished from the start.</p><p>Choose the space that matches your daily rhythm: a streamlined studio, a one-bedroom with room to settle in, a two-bedroom with added flexibility, or an elevated penthouse with upgraded finishes. Inside select homes, details like chef-caliber kitchens, gas cooking, quartz countertops, walk-in closets, in-home washer and dryer, solar shades, and framed glass balconies bring function and style together. Explore the floor plan cards below, compare current pricing and availability, then view the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your next layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos set the tone.</strong> In the Rise gallery, you can picture your day in crisp, light-filled interiors, from chef-caliber kitchens with sleek cabinetry and quartz counters to living spaces framed by city views and select glass balconies. Move through the images and you’ll see the details that give each home its polished feel: warm wood-style flooring, pendant lighting, spa-inspired baths, and open layouts designed to feel bright without trying too hard.</p><p>Then step into the scenes beyond your front door: a 7th-floor terrace with a saltwater pool and cabanas, an outdoor kitchen made for unhurried evenings, a spacious fitness center with Peloton bikes, and a 28th-floor lounge where Midtown Atlanta becomes the backdrop. Browse the gallery, explore the <a href=\"/amenities\">amenity spaces</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Rise in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore from every angle.</strong> Use the interactive map to browse available apartments, see the surrounding Midtown setting, and get a feel for walkable access to top employers, city experiences, and a central location connected to the greater Atlanta area.</p>",
  "property_pets_blurb": "<p><strong>A polished home base for paws.</strong> At Rise, pet-friendly living is built into the day—not treated like an afterthought. Take elevator rides and lobby arrivals with ease, then head to the <a href=\"/amenities\">Pet Oasis</a> for indoor play or a quick refresh at the spa-style wash station after walks around Midtown Atlanta. Pet care conveniences, controlled access, package service, and 24-hour concierge support help keep daily logistics smooth, while open floor plans, in-home laundry, and select balconies give you and your companion room to settle in.</p><p>Dogs and cats are welcome within the posted policy, with details below for pet limits, fees, rent, and size guidelines. Want to see the spaces that make pet routines easier? <a href=\"/schedule-a-tour\">Schedule a tour</a> and picture everyday life with your pet at Rise.</p>",
  "property_referafriend_blurb": "<p><strong>Share the view from Ascent Midtown.</strong> Invite a friend to experience upscale high-rise living with iconic architecture, extraordinary residences, best-in-class amenities, and walkable access to the city experiences that make this address stand out.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, elevated.</strong><br>Log in to manage your Ascent Midtown experience—from rent payments to maintenance requests and account updates—all in one convenient place. Keep life moving in your upscale Midtown high-rise with the same sophisticated, modern ease that defines home here.</p>",
  "property_reviews_blurb": "<p><strong>See what residents and visitors are saying about Rise.</strong> Reviews point to a polished Midtown Atlanta living experience shaped by attentive service, beautiful surroundings, and a team that makes each step feel clear and personal. Guests repeatedly call out Diego, Ebony, Taye, and Tameka for being welcoming, knowledgeable, patient, and quick to turn questions into answers.</p><p>You’ll also find praise for stunning views, spacious chic apartments, high-end modern finishes and appliances, and “quick and reliable maintenance.” Whether you’re comparing floor plans or planning a visit, these reviews offer a candid look at the care, professionalism, and day-to-day comfort people notice most at Rise.</p>",
  "property_created_at": "1787752404901",
  "property_scheduletour_blurb": "<p><strong>See Midtown from a new perspective.</strong> Tour Ascent Midtown and experience the upscale high-rise design, extraordinary residences, and best-in-class amenities that make everyday living feel elevated. Schedule your visit today and see how sophisticated, modern, stunning living looks in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The leasing team will be in touch soon to help you take the next step. In the meantime, picture life in an upscale, modern high-rise with iconic architecture, extraordinary residences, and best-in-class amenities in a central Atlanta location.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Rise before you arrive.</strong> Start with the community and entrance virtual tours, then move inside apartment walkthroughs that let you compare studio, one-bedroom, and two-bedroom layouts from wherever you are. As you click through each space, notice the open flow, tall ceilings, natural light, wood-style flooring, sleek kitchens, spa-inspired baths, in-home laundry, and the way select balconies frame the Midtown Atlanta high-rise view.</p><p>Use these tours to narrow your favorites, revisit the details that matter, and get a clearer sense of how each home lives before you explore <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule an in-person tour</a>.</p>",
  "property_copyright": "2026 All Rights Reserved. Rise",
  "property_seo_title_home": "Rise |  Apartments in Atlanta, GA",
  "property_seo_description_home": "Elevate your lifestyle at Rise in Atlanta! Enjoy stunning views, spacious floor plans, and luxurious amenities. Find your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | Atlanta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at Rise in Atlanta, GA. From studios to spacious two-bedrooms, browse our diverse floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Atlanta, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Rise in Atlanta! Enjoy resort-style amenities, spacious layouts, and luxury finishes for your ultimate comfort.",
  "property_seo_title_gallery": "Gallery | Apartments in Atlanta, GA",
  "property_seo_description_gallery": "Discover Rise in Atlanta: stylish studios, luxury amenities, stunning views. Experience comfort, convenience, and community. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Rise Apartments",
  "property_seo_description_virtualtours": "Step into a vibrant lifestyle at Rise in Atlanta, GA! Take a virtual tour and explore stunning studio, one, and two-bedroom apartments designed for you.",
  "property_seo_title_interactivemap": "Interactive Map | Rise Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Rise in Atlanta. Use our interactive community map to explore stunning studios, 1 & 2-bedroom apartments with top-notch amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Atlanta, GA",
  "property_seo_description_neighborhood": "Explore Atlanta's vibrant Rise Apartments neighborhood! Cozy studios to spacious two-bedrooms await, plus local gems and hotspots to discover!",
  "property_seo_title_contact": "Contact Us | Rise",
  "property_seo_description_contact": "Connect with Rise in Atlanta! Inquire about our stylish studio, one, and two-bedroom floor plans. Your new home awaits—reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Atlanta, GA",
  "property_seo_description_faqs": "Find the answers to your questions on our FAQs page—explore community amenities, apartment features, and more at Rise, your Atlanta oasis!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Atlanta, GA",
  "property_seo_description_reviews": "Experience luxury at Rise in Atlanta! Enjoy 24/7 concierge, stunning views, and vibrant amenities that elevate your lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Atlanta, GA",
  "property_seo_description_applynow": "Elevate your lifestyle at Rise in Atlanta with stylish studios and spacious two-bedroom homes, complemented by luxury amenities and stunning views!",
  "property_seo_title_residentaccess": "Resident Access | Rise",
  "property_seo_description_residentaccess": "Unlock convenience at Rise in Atlanta! Log in to your resident portal for rent payments, maintenance requests, and effortless community living.",
  "property_seo_title_referafriend": "Refer A Friend | Rise",
  "property_seo_description_referafriend": "Elevate your living experience at Rise in Atlanta—refer a friend today and build a vibrant community where great friends become great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Rise",
  "property_seo_description_scheduletour": "Experience modern living at Rise in Atlanta, GA. Schedule a tour today and see how our vibrant apartment community can elevate your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Rise",
  "property_seo_description_privacy": "At Rise in Atlanta, we prioritize your privacy. Learn how we protect your information and enhance your living experience. Check out our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Rise",
  "property_seo_description_accessibility": "At Rise in Atlanta, we prioritize digital inclusion with seamless access and thoughtful design. Join our vibrant community today!",
  "property_seo_title_sitemap": "Sitemap | Rise",
  "property_seo_description_sitemap": "Navigate through Rise's sitemap and uncover a vibrant community in Atlanta, GA. Your perfect apartment awaits—let's make it yours today!",
  "property_seo_title_thankyou": "Thank You | Rise",
  "property_seo_description_thankyou": "Thank you for reaching out to Rise in Atlanta, GA! Our team will be in touch soon to help you discover your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787754101744",
  "amenities": [
    {
      "id": "ec_d7c7570689dbaa21cf786036",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d23a98becf3e8a8106e030e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_689ee95eb33a4e9b4ae09908",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b2bb29a7124cab7aeef7f71",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_131ca408aabd5c9dea280e3b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00b289da20bb1a0970ea305b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Video Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3b1acd8f61a30a8bd6426ef",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Dry Cleaning Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4df91ac850a81560b3f1c88",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d771b292234de2637e9763b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2b406d079f6d5f6abb3338d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Maid Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b48ffdd18592e9b6766a761f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site Retail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e6b32e8e8ef04f6f9177af1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22d09c6f99c03492e7097255",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33e0865f05484fda9015f82d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ee3cc090c14dac22b847ae3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46b07a269e6d436eb2de08df",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_524ff0da683e12e67dec992e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94da249b9c56071dab6186ea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e9699470ef11371d25048bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Grocery Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6c3f8214ac6321808e3d5cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3c800f7216fd45271d0e56e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Meal Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31a6e094415a891d48af9421",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "On-Site ATM",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04a3784ea77335186b63e9fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c08d5fa772473193e26dc7e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Care",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_869af8f9c168711a7c73b7f8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_823814b6b86fd117be297a8d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f052ecfd90eb40b32d5a9ba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f308b4159122c9860605da61",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd03e1661d396c2ddbe8390d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08952d90cf816b795da021e1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Corporate Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25a3fce738819afa27144470",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Breakfast/Coffee Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c146955248e1587b9cde6e13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d5d0ab7d347561dd96fa96e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd4c2dae1d7dda4412580023",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b68a1b53a07d3e473fa17cce",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bd7d34980149b5cbae07a93",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd27d2543605f36e4f7f289f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0e3d0320b7f5b87fe05fd4f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad5aeafe9539c53303b5947a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e78f5019c052bc6f732f6201",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f01d77e42f4fc3a96755712",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35fdfab8aaeca2d8da5d0a3d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Roof Terrace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dda3f2a91298f3d4b2144198",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfaa62c265431db1c1fcbb57",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb98a8368fce9f27213f2cbd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d43a9d3e7cc08debadd4c03",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Media Center/Movie Theatre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64c85d9e1cb1d745f8c56f52",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bcb179b04fe6c9505fe998d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Study Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06d560b9334c66027d31975c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk To Campus",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad71f00846c270d6141ff912",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "24-hour resident concierge services for your convenience",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63af0de142a9481abca2c69a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "28th Floor Resident Lounge With Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_391cd2d346ab595e951fb2d0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "3 floors of penthouse living w/ upgraded features & finishes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d92918e981e58f17da10e391",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "4,000 SF Fitness Center W/Peloton Bikes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4007e67cf32b605cbed1ec3b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "4,000 SF, state-of-the-art fitness center feat Peloton™",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9581a80eaf427a3bf7e61570",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "7th floor terrace w/ luxe pool & custom cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1c37f758c9977cc5f5fb6c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "7th Floor Terrace W/Saltwater Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a5ff2bd4c730842c2e581a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "9' ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1a6566ec62001a3056dedcb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "9' Ceilings & Open Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecded055b779692b47999252",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "9’ ceilings & open floor plans for ample natural light",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c779615357f2705ea44fa07",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Amazon Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7136df3c6841774a9170a906",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Bar area perfect for cooking and entertaining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56bdf81b28a7bc6e43de3e1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Bluetooth Keyless Door Locks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa7ce451b56d083aef5a4c3a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Chef-Caliber Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c3135481dd570a9464af033",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Chef-caliber kitchens featuring sleek cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90d80684a6570256d4afb85a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled access community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bc1bca4584fda3ee9380de0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Covered Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa28a9fb079e82a1f993ec75",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Cozy Fireplace Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00ee6685e858c58620f8aec5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Designer Ceiling Fans In Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a7ec1bd2464f4edcb91e4f4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Efficient Gas Cooking Ranges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52f6e9850172efd9f0c89e4a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Expansive Sun Deck With Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6fd9509e4a7ffa15a0635d9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace lounge great for hanging with friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d934c3cd6c2bea2f31f3247",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness On Demand Programs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f786ad315a58914ad6bfb74c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Glass Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26edcb7988bc51b371f3ea1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed glass balconies for unobstructed views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a92d1fe51ff16afdb0e89042",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-size, washer & dryer included in each residence",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a55401a81bdf5d85678e1f4d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Gas cooking and quartz countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6969cf05c741cc1dddb2e74f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Gas Stoves",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_573ab6a4fc9468211d1ccd86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Glass Showers W/Porcelanosa Tile",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9fab2b96008bef8c42d78cd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Glass showers with porcelanosa tile surrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4467719eeaf3d8787fe7b124",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "High speed elevator access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eb8e2cfa9b431306da80ea7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "High-Speed Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_122a0231baba5baffc410a60",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Incredible Midtown Atlanta location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d3ace91e5f5ea2863b172c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Luxurious spa baths w/ granite counters and halo lit mirrors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cb4192e218572144806bf5b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Other",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7afde4b65e5199c95b66697",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Kitchen W/BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e05d7120a10587b6a59d370b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pendant light fixtures in dining areas *",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c582b495c40d308fc43dd55",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Penthouses Available W/Upgraded Finishes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ecc8332c05c8086fc45a85c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Oasis W/Spa & Indoor Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9701b57e5b62909f575652e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Plank, Wood-Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56e507383c22c1e75345fff7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Programmable Thermostat Technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df388d2da50b16b2a3575051",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Programmable thermostats technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1deadb24abaa3309e250ab43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident lounge on 28th floor with spectacular city views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5482b40cce3c91fedf268979",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Black Slate Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3588e95689ce387e3af2f249",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Cabinetry & Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_264c7c9e576049e2d617c33d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Solar shades included in each home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70514e72b3cf09f3ecea769e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Solar Shades Included In Every Home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5f3c24433e888d6847244d2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Spa baths w/ granite counters and halo lit mirrors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efa80f4ef06789051f83e39d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Spacious walk-in closets w/ wood shelving for extra storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbd0a392fbff305ea089f016",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless steel",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6154a75e1f71dc9331b91c61",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Undermounted sink with pull down Faucet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7e9f309df949524989b4e3c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless steel, undermounted sink with pull down faucet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dadf9eca03837be2ac98a271",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Studio, one, one & two-bed residences",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41cf24a568cbf6e7fe0a286c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Stylish Pendant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eb150e3d434afb0ad1180fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Summer kitchen including grills and outdoor dining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee51bf41e7f192cfac81ae22",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile-inspired floors in kitchen, living and dining rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6edcfdd8aeef2647757c3b8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "USB Outlets In Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4799dc14f5db1c1ce6d1ae68",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "USB outlets in the kitchen island",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba2395aefe6457b1b538f03d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "We offer both the vinyl plank and real wood flooring in our Penthouses",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a2ae77512a54198ddf357b3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Whirlpool™ black slate appliance suite *",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9b4b70361d81bc95c95258f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f84253338a05ff0c5cb95ade",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f37b9e9264aabda9f6bcee77",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2214ce8d73be31fd1b3de0ba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41dd3f8b6002b280cddb9c10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_081ae672d882a0edc27284ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_253982dd3404ae72c49334b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1aae7fc98d5f5fddc2a351d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9ebd4e25632aae0b8ece10b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e04ecdf71822c40897117825",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e4a0c1edd5dce94f71553bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25d5f99c2969931227ce54d3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Framed Mirrors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8821e609b7a55660db72716",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9e43b455cbbaff80295156e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2d0634830453012468a4fcf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b506357a506e3c694f535820",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d663bb6f8ac5bf357cf0d998",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31027f701e4304a556a4dcea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4029c97bec6ce8c44a7762e4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a596e4fb6ac3acd77f487caa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44de414784532302d83369b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24d7a9c7bf1c15f78fd432c7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e8ec3659de7074f3fc57ae0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4729bc1b15d83cc9c2f8eb6c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48b97e7b0dfea92bcb44db7c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Island Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08bec303440e1eefe25b7506",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4529057226b3845af81cf8a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a359ba23c51ed96db60637ed",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_019f8b2322d4748fefa79ddc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4b1fed4c1eb87c4c6830273",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13406c3f5d0866e2520b867f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4637d7e739e18df532405cbc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1d421ff7ec5096dd4632e94",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Den",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d507650628ae75ccb2bc6bd0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37a1a7d53c0d2495f0fecc13",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b62cf829b59141885fd1bacd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6789c17bae4ef60a41903e0a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc807b3365cf392df47580aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_228ec716e761cfc68cdee501",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_647f6fc2cd8df19caf9bfb88",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_900855f9865db1ec5ede1288",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-e00f-725c-b48a-5fdfacaff206.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and city skyline in the background.",
        "public_id": "01a03e5c-e00f-725c-b48a-5fdfacaff206",
        "storage_key": "property/6767906449167739/01a03e5c-e00f-725c-b48a-5fdfacaff206.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a breathtaking city view.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and city skyline in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6RE5ygZ3ydSz3Tw2bsyp3kOkgzZ3o7EnxORvOwbdxqc/102/image.jpg"
    },
    {
      "id": "ec_f40b0abafeb315c3395552a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-e00f-725c-b48a-5fdfacaff206.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and city skyline in the background.",
        "public_id": "01a03e5c-e00f-725c-b48a-5fdfacaff206",
        "storage_key": "property/6767906449167739/01a03e5c-e00f-725c-b48a-5fdfacaff206.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a breathtaking city view.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and city skyline in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6RE5ygZ3ydSz3Tw2bsyp3kOkgzZ3o7EnxORvOwbdxqc/102/image.jpg"
    },
    {
      "id": "ec_6070137de0cacb6b3c5338b7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-dc48-738a-9a3a-4fbbae5b19ee.webp",
      "image_media": {
        "alt_text": "Exterior view of a tall apartment building with many balconies.",
        "public_id": "01a03e5c-dc48-738a-9a3a-4fbbae5b19ee",
        "storage_key": "property/6767906449167739/01a03e5c-dc48-738a-9a3a-4fbbae5b19ee.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Modern high-rise apartment building with numerous balconies, offering urban living.",
      "link": "false",
      "alt_text": "Exterior view of a tall apartment building with many balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3ihoyY3f_RB9dzMS_iZvQOBeAS33C0uohitEZF-PnWA/102/image.jpg"
    },
    {
      "id": "ec_a6325566c29bce5744f8e3e5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-d8af-703c-979e-d418b6b37b22.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern high-rise apartment building with balconies and large windows.",
        "public_id": "01a03e5c-d8af-703c-979e-d418b6b37b22",
        "storage_key": "property/6767906449167739/01a03e5c-d8af-703c-979e-d418b6b37b22.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "A striking modern high-rise apartment building with numerous balconies and expansive windows, offering a glimpse of urban living.",
      "link": "false",
      "alt_text": "Exterior view of a modern high-rise apartment building with balconies and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/16BwNIJbNxF64CZoZUCy92Yf_73QK7bvQeXBtBnyNn4/115/image.jpg"
    },
    {
      "id": "ec_62b77abe5e36eeb44eb5fd63",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-d8ba-7210-8555-b3f8f20c9cad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and large window overlooking balcony.",
        "public_id": "01a03e5c-d8ba-7210-8555-b3f8f20c9cad",
        "storage_key": "property/6767906449167739/01a03e5c-d8ba-7210-8555-b3f8f20c9cad.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "A sleek, modern kitchen featuring stainless steel appliances, ample white cabinetry, and a stylish tiled backsplash, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and large window overlooking balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HgcTzVdD9XVnxnb9Jk4_jqlo97nrviIkCMyMQRGHcz4/105/image.jpg"
    },
    {
      "id": "ec_91067e487f4f39d760cc01bd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-c6ac-75bb-8a68-f3afe85ac412.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets.",
        "public_id": "01a03e5c-c6ac-75bb-8a68-f3afe85ac412",
        "storage_key": "property/6767906449167739/01a03e5c-c6ac-75bb-8a68-f3afe85ac412.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Step into a sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and a spacious layout perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mc_COKWOt4RHUbzpRL8fzy_1DLyTpPvCB93X6ILBBJo/110/image.jpg"
    },
    {
      "id": "ec_ccd9094d0cbb59cf71a12570",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-f4e5-706c-a0e7-2f14c6a9d074.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and an island with a sink.",
        "public_id": "01a03e5c-f4e5-706c-a0e7-2f14c6a9d074",
        "storage_key": "property/6767906449167739/01a03e5c-f4e5-706c-a0e7-2f14c6a9d074.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek white cabinets, quartz countertops, and a large island with a sink. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and an island with a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/y8R1bMPuZf8VKGbZkMvJMYCvyK0SXJPNzzWVI6nIQRU/106/image.jpg"
    },
    {
      "id": "ec_b744961181ccc4527955bf34",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-f226-72da-8a46-3a59d2b383e1.webp",
      "image_media": {
        "alt_text": "Modern living room with city views, featuring a sofa, coffee table, and large windows.",
        "public_id": "01a03e5c-f226-72da-8a46-3a59d2b383e1",
        "storage_key": "property/6767906449167739/01a03e5c-f226-72da-8a46-3a59d2b383e1.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Enjoy stunning city vistas from the comfort of this modern and stylish living room, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Modern living room with city views, featuring a sofa, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2MJDrihOzCsLHKblcYiD51m6zmaS4hoauChlyFQ2lpg/115/image.jpg"
    },
    {
      "id": "ec_ae73372e952464efbd12f81c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-f4d5-7339-a0dd-5ae7433f3efd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray subway tile backsplash, and white countertops.",
        "public_id": "01a03e5c-f4d5-7339-a0dd-5ae7433f3efd",
        "storage_key": "property/6767906449167739/01a03e5c-f4d5-7339-a0dd-5ae7433f3efd.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Stylish apartment kitchen featuring modern cabinetry, stainless steel appliances including a microwave and dishwasher, and a sleek subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, gray subway tile backsplash, and white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/s55Cy7p5or3ZFCsNnfUNR3DrfiUxRFLOrheMlUVoYrA/114/image.jpg"
    },
    {
      "id": "ec_913200b2b3574917f3990ad4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-0420-73ee-a30c-e704700cb48e.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating, bar, fire pit, and city skyline view.",
        "public_id": "01a03e5d-0420-73ee-a30c-e704700cb48e",
        "storage_key": "property/6767906449167739/01a03e5d-0420-73ee-a30c-e704700cb48e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our rooftop lounge, featuring a modern bar, comfortable seating areas, and a cozy fire pit. Perfect for socializing and relaxing.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating, bar, fire pit, and city skyline view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lyJRnO-ZvwcX7OSEMMCZpRJpewFy_Y_8zqP-eVGcQoo/102/image.jpg"
    },
    {
      "id": "ec_f988d42787238df719f480e7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-fc00-7619-a149-475ba64ff086.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with cardio machines, weights, exercise balls, and yoga mats.",
        "public_id": "01a03e5c-fc00-7619-a149-475ba64ff086",
        "storage_key": "property/6767906449167739/01a03e5c-fc00-7619-a149-475ba64ff086.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide range of cardio machines, free weights, resistance bands, and yoga equipment for residents.",
      "link": "false",
      "alt_text": "Modern apartment fitness center with cardio machines, weights, exercise balls, and yoga mats.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/42WosMyuYyD81GaRcDexZ8Q6krR5HIYve_auApO--wg/119/image.jpg"
    },
    {
      "id": "ec_b3f65cf359826b8d0648490e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-11b4-7643-aec9-0c1dcc4a3863.webp",
      "image_media": {
        "alt_text": "Rooftop seating area with city skyline view.",
        "public_id": "01a03e5d-11b4-7643-aec9-0c1dcc4a3863",
        "storage_key": "property/6767906449167739/01a03e5d-11b4-7643-aec9-0c1dcc4a3863.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy exclusive rooftop lounge areas with stunning city views and comfortable, modern seating.",
      "link": "false",
      "alt_text": "Rooftop seating area with city skyline view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DBOGSfWpSJTb359L49Ao6EJjYIF_3ss0jLEya1lK2MQ/110/image.jpg"
    },
    {
      "id": "ec_1c3f7c3aeb5b65616e5d7570",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-0efe-746e-acbe-839144fdebdb.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with fire pit and city skyline at dusk.",
        "public_id": "01a03e5d-0efe-746e-acbe-839144fdebdb",
        "storage_key": "property/6767906449167739/01a03e5d-0efe-746e-acbe-839144fdebdb.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy an evening gathering around the fire pit in our stylish rooftop lounge, offering breathtaking city views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with fire pit and city skyline at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pgZK7JYk2woH-28uB_8x3LJJxhJcRMojjwhbc8T8-Ik/116/image.jpg"
    },
    {
      "id": "ec_0f81e056d97267190fdb8537",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-17d1-779b-87bd-0c44b5e15d31.webp",
      "image_media": {
        "alt_text": "Luxurious apartment building lobby with modern art and comfortable seating.",
        "public_id": "01a03e5d-17d1-779b-87bd-0c44b5e15d31",
        "storage_key": "property/6767906449167739/01a03e5d-17d1-779b-87bd-0c44b5e15d31.webp",
        "width": 1478,
        "height": 2048
      },
      "title": "Community",
      "description": "Step into our grand lobby, featuring contemporary art, plush seating, and a striking sculptural element, creating an inviting atmosphere for residents and guests.",
      "link": "false",
      "alt_text": "Luxurious apartment building lobby with modern art and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6MPcIjWpoDD0WXLiZ9Muo4H0WEHiKQtNcHEt6TbaFSQ/111/image.jpg"
    },
    {
      "id": "ec_b66ba91a577685c58c730947",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-2169-7095-ac0d-100a9529b4ff.webp",
      "image_media": {
        "alt_text": "Luxurious communal dining area with a long granite table, modern pendant lights, and city views at sunset.",
        "public_id": "01a03e5d-2169-7095-ac0d-100a9529b4ff",
        "storage_key": "property/6767906449167739/01a03e5d-2169-7095-ac0d-100a9529b4ff.webp",
        "width": 2048,
        "height": 1337
      },
      "title": "Community",
      "description": "Host your next event in this stunning communal dining space, perfect for gatherings and celebrations, featuring elegant decor and panoramic city views.",
      "link": "false",
      "alt_text": "Luxurious communal dining area with a long granite table, modern pendant lights, and city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aySMqPevSnRph_tycy--9d0X-VFwgBr58SxGbcKcFx4/116/image.jpg"
    },
    {
      "id": "ec_69cdaaf2d93fdf6a54a8251b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-1e94-72cb-a396-d202b34c9bde.webp",
      "image_media": {
        "alt_text": "Luxurious living room with city views, featuring a large sectional sofa, modern decor, and bicycles.",
        "public_id": "01a03e5d-1e94-72cb-a396-d202b34c9bde",
        "storage_key": "property/6767906449167739/01a03e5d-1e94-72cb-a396-d202b34c9bde.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Experience elegant living in this spacious apartment, complete with stunning city vistas, plush seating, and unique decorative elements.",
      "link": "false",
      "alt_text": "Luxurious living room with city views, featuring a large sectional sofa, modern decor, and bicycles.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/K4TusfrtgwjiDaKzpZ97AWkEhb5kfih0dxy-NV4WJnE/110/image.jpg"
    },
    {
      "id": "ec_9b3e5c4152e4f0e2d9720df3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-2d24-736b-84b9-2cffdadc992c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with outdoor kitchen and seating at sunset.",
        "public_id": "01a03e5d-2d24-736b-84b9-2cffdadc992c",
        "storage_key": "property/6767906449167739/01a03e5d-2d24-736b-84b9-2cffdadc992c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy stunning sunset views from our rooftop lounge, complete with an outdoor kitchen and comfortable seating, perfect for entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge area with outdoor kitchen and seating at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-AWIjKtU61QYL0dNXwAo84D7YWU_c8PzEOVsuJwkxF4/116/image.jpg"
    },
    {
      "id": "ec_d61d325fe61c34e35373ef5f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3475-71d7-be89-0e1017b87000.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
        "public_id": "01a03e5d-3475-71d7-be89-0e1017b87000",
        "storage_key": "property/6767906449167739/01a03e5d-3475-71d7-be89-0e1017b87000.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the pool with comfortable lounge chairs and shaded cabanas. Enjoy a resort-style experience at our community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4N4NL3hKfFo7U58N9fqscC4ig1sn9RWIS5KybxRTQo8/110/image.jpg"
    },
    {
      "id": "ec_bc9b8db90d5444436de38564",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3194-7519-ac06-bc809cb5db84.webp",
      "image_media": {
        "alt_text": "Modern living room with city view at dusk",
        "public_id": "01a03e5d-3194-7519-ac06-bc809cb5db84",
        "storage_key": "property/6767906449167739/01a03e5d-3194-7519-ac06-bc809cb5db84.webp",
        "width": 2048,
        "height": 1303
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large sectional sofa, stylish coffee tables, and floor-to-ceiling windows with a stunning city skyline view at sunset.",
      "link": "false",
      "alt_text": "Modern living room with city view at dusk",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dOeIKphEHPLeEY_vzyPbEAePnSITh_Stk4WjXgfywyw/116/image.jpg"
    },
    {
      "id": "ec_b4e83d0da54f2b8f81cc7de4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3be8-724d-be1a-81d33f413f3e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large granite table and chairs, wet bar, and entertainment center.",
        "public_id": "01a03e5d-3be8-724d-be1a-81d33f413f3e",
        "storage_key": "property/6767906449167739/01a03e5d-3be8-724d-be1a-81d33f413f3e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Gather in the stylish community lounge, featuring a wet bar, comfortable seating, and modern entertainment area, perfect for residents to socialize and relax.",
      "link": "false",
      "alt_text": "Modern lounge area with a large granite table and chairs, wet bar, and entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G5bG62mzMR66ovOwW1nVzy2oej4zrALPxlTxd9kb0Ag/106/image.jpg"
    },
    {
      "id": "ec_7dda0983fbd67f23e5fcc9bf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3eb8-776a-86c9-e1ca858dfb74.webp",
      "image_media": {
        "alt_text": "Modern reception desk with decorative wood paneling and contemporary pendant lights.",
        "public_id": "01a03e5d-3eb8-776a-86c9-e1ca858dfb74",
        "storage_key": "property/6767906449167739/01a03e5d-3eb8-776a-86c9-e1ca858dfb74.webp",
        "width": 2048,
        "height": 1391
      },
      "title": "Community",
      "description": "Welcome to our stylish lobby featuring a sleek reception desk, modern lighting, and elegant decor, creating a sophisticated first impression.",
      "link": "false",
      "alt_text": "Modern reception desk with decorative wood paneling and contemporary pendant lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eusvWLn7V_KZZaNxqCxFaxMR3sfhhmfi36ua9cKJans/119/image.jpg"
    },
    {
      "id": "ec_9805b83e830c17bc5b22c6ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-4c02-705c-840d-892f3a7ee9d8.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace and city view",
        "public_id": "01a03e5d-4c02-705c-840d-892f3a7ee9d8",
        "storage_key": "property/6767906449167739/01a03e5d-4c02-705c-840d-892f3a7ee9d8.webp",
        "width": 2048,
        "height": 1308
      },
      "title": "Apartment",
      "description": "Elegant living space featuring a contemporary fireplace, plush seating, and a stunning panoramic view of the city skyline.",
      "link": "false",
      "alt_text": "Modern living room with fireplace and city view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/XSW7dFObLUo-zXTEH5FmdqNtdinookQaXFX5NxkVzgY/102/image.jpg"
    },
    {
      "id": "ec_291f75cf934d04e300a2b59b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-4d43-77bd-9c3b-5eb9ac1c63c4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a city view.",
        "public_id": "01a03e5d-4d43-77bd-9c3b-5eb9ac1c63c4",
        "storage_key": "property/6767906449167739/01a03e5d-4d43-77bd-9c3b-5eb9ac1c63c4.webp",
        "width": 2048,
        "height": 1401
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring sleek white cabinetry, a full suite of stainless steel appliances, granite countertops, and stunning city views from the large windows. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xhNB2W94tltGKury0E08ZL3mNaLlTLl3ed4wsi0wAo0/119/image.jpg"
    },
    {
      "id": "ec_6ac79ab96f6e1a08feb170b6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-53e9-7089-a9a7-58ad65ae92cd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and dark countertops.",
        "public_id": "01a03e5d-53e9-7089-a9a7-58ad65ae92cd",
        "storage_key": "property/6767906449167739/01a03e5d-53e9-7089-a9a7-58ad65ae92cd.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Stunning U-shaped kitchen featuring stainless steel appliances, sleek white cabinetry, and durable dark countertops, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and dark countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ad1Dulsw7g8dXLeecQ9TtJZgR7FG5JLus-T2u6TtTYk/111/image.jpg"
    },
    {
      "id": "ec_5bed8b354a8ecd2d53495ba4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-5b32-7539-88fc-f519f3e0a8d2.webp",
      "image_media": {
        "alt_text": "Modern living room with city view, featuring a sofa, coffee table, and bar stools.",
        "public_id": "01a03e5d-5b32-7539-88fc-f519f3e0a8d2",
        "storage_key": "property/6767906449167739/01a03e5d-5b32-7539-88fc-f519f3e0a8d2.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Sophisticated living room with a stunning city skyline view. Features a plush sofa, a modern coffee table, and a sleek kitchen island with bar stools, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room with city view, featuring a sofa, coffee table, and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RVS_C74l007ZMiTDrfBpsblBrsyM-7gKmDxeqo0SZGQ/102/image.jpg"
    },
    {
      "id": "ec_ab4aa8294df37fcdfe24545f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-5994-72cc-976b-c066d40cae4d.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, modern art, and city views.",
        "public_id": "01a03e5d-5994-72cc-976b-c066d40cae4d",
        "storage_key": "property/6767906449167739/01a03e5d-5994-72cc-976b-c066d40cae4d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant decor, and stunning views of the cityscape.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a king-size bed, modern art, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yBwpmvkPNPO60pjk4xopWLV8f7nwhtaiyqFERIFcz-E/104/image.jpg"
    },
    {
      "id": "ec_ac30c0e707d8c42682c1d2cb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-6230-710b-b8f4-1d6518b9ff05.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, walk-in shower, and bathtub with shower curtain.",
        "public_id": "01a03e5d-6230-710b-b8f4-1d6518b9ff05",
        "storage_key": "property/6767906449167739/01a03e5d-6230-710b-b8f4-1d6518b9ff05.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a sleek double vanity with illuminated mirror, a separate walk-in shower, and a deep soaking tub with a stylish shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, large mirror, walk-in shower, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tN-VMf87mW3GzJ_5i7QNSrDzhzInFRnVUClj-uypxzA/113/image.jpg"
    },
    {
      "id": "ec_3febdd02dcd56f8947d74b32",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-674b-74a3-aa3d-75eabb202fb4.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window overlooking the city and an adjacent living room.",
        "public_id": "01a03e5d-674b-74a3-aa3d-75eabb202fb4",
        "storage_key": "property/6767906449167739/01a03e5d-674b-74a3-aa3d-75eabb202fb4.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a city view, featuring a plush queen-size bed and elegant decor. Opens to a stylish living area.",
      "link": "false",
      "alt_text": "Bedroom with a large window overlooking the city and an adjacent living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RNfWRBHDbm6fZubhLRSU0DRaptmfb8MlcVrF1TJ189E/105/image.jpg"
    },
    {
      "id": "ec_6e749ea3cbb71274bbb74733",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-2d24-736b-84b9-2cffdadc992c.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with outdoor kitchen and seating at sunset.",
        "public_id": "01a03e5d-2d24-736b-84b9-2cffdadc992c",
        "storage_key": "property/6767906449167739/01a03e5d-2d24-736b-84b9-2cffdadc992c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy stunning sunset views from our rooftop lounge, complete with an outdoor kitchen and comfortable seating, perfect for entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge area with outdoor kitchen and seating at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/4h8NPPKdN6YmYPyyrQutPOEcXts9N09NAQdfgVHV_ls/111/image.jpg"
    },
    {
      "id": "ec_bfc0dd981b7ae624dd91996b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-7e51-72be-b3c2-672adb3e6bbc.webp",
      "image_media": {
        "alt_text": "Rooftop pool with lounge chairs at sunset",
        "public_id": "01a03e5d-7e51-72be-b3c2-672adb3e6bbc",
        "storage_key": "property/6767906449167739/01a03e5d-7e51-72be-b3c2-672adb3e6bbc.webp",
        "width": 2048,
        "height": 1362
      },
      "title": "Community",
      "description": "Relax by our stunning rooftop pool, surrounded by palm trees and city views. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Rooftop pool with lounge chairs at sunset",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SgXPjwLbURXqgX9xeO_qWRjGX6RXY3XQArCopCkh0SU/112/image.jpg"
    },
    {
      "id": "ec_004a20e448ccb7cc2db96093",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-7548-775c-9045-3e0e38fb8275.webp",
      "image_media": {
        "alt_text": "Luxurious living room with modern fireplace, built-in shelving, and city view.",
        "public_id": "01a03e5d-7548-775c-9045-3e0e38fb8275",
        "storage_key": "property/6767906449167739/01a03e5d-7548-775c-9045-3e0e38fb8275.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "Experience elevated living in this stunning apartment's spacious living room, featuring a sleek fireplace, elegant built-in shelving, and breathtaking panoramic city views.",
      "link": "false",
      "alt_text": "Luxurious living room with modern fireplace, built-in shelving, and city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k5yTHuEU0h196kKv3ijY2BQDY2U829yqeI_EFQvJrug/111/image.jpg"
    },
    {
      "id": "ec_8683fc1188d2e667aabf9516",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-779a-70ca-a4b8-4d2165061d5a.webp",
      "image_media": {
        "alt_text": "Ascent building exterior at dusk with city lights in the background.",
        "public_id": "01a03e5d-779a-70ca-a4b8-4d2165061d5a",
        "storage_key": "property/6767906449167739/01a03e5d-779a-70ca-a4b8-4d2165061d5a.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring the Ascent sign illuminated at dusk, with a vibrant cityscape and highway in the distance.",
      "link": "false",
      "alt_text": "Ascent building exterior at dusk with city lights in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Mi_EndE1ifbbbfqZkBmPGIsvzEHlrnYC6Zc61QSlM8k/112/image.jpg"
    },
    {
      "id": "ec_6d6298ef85bb71d6083ef8aa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-75d3-7618-a568-c1d387632624.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with fire pit, seating pods, and city skyline at dusk.",
        "public_id": "01a03e5d-75d3-7618-a568-c1d387632624",
        "storage_key": "property/6767906449167739/01a03e5d-75d3-7618-a568-c1d387632624.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Enjoy breathtaking city views from our elevated rooftop lounge, featuring a cozy fire pit, comfortable seating pods, and lush landscaping. An ideal spot for relaxation and socializing.",
      "link": "false",
      "alt_text": "Rooftop lounge area with fire pit, seating pods, and city skyline at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JaBC2eOu59w9gxMWmR7Lbr87JyLSTKDZ0Szk7EvJLuE/110/image.jpg"
    },
    {
      "id": "ec_478c33e94af320985fb45e3c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3475-71d7-be89-0e1017b87000.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
        "public_id": "01a03e5d-3475-71d7-be89-0e1017b87000",
        "storage_key": "property/6767906449167739/01a03e5d-3475-71d7-be89-0e1017b87000.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax by the pool with comfortable lounge chairs and shaded cabanas. Enjoy a resort-style experience at our community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TwZnEdpPqZmsmqPcCgPZpQ2nL-SYHVtbvGcCSYG02sQ/112/image.jpg"
    },
    {
      "id": "ec_3498c5b4887a89a7e6f30aa1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-8e64-72ba-b1c6-41520ada92f3.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with pool and bar seating.",
        "public_id": "01a03e5d-8e64-72ba-b1c6-41520ada92f3",
        "storage_key": "property/6767906449167739/01a03e5d-8e64-72ba-b1c6-41520ada92f3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool and expansive outdoor lounge with bar seating and dining tables, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Outdoor lounge area with pool and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pbV2HP6ga-78I06Oh0wOmJ0zGEViB3qR0XPtoV1Rvbg/110/image.jpg"
    },
    {
      "id": "ec_b508f6be3a1d9aa32d4139f5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-837d-76bb-846a-8db6f8ed4900.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines, weight machines, and large windows overlooking greenery.",
        "public_id": "01a03e5d-837d-76bb-846a-8db6f8ed4900",
        "storage_key": "property/6767906449167739/01a03e5d-837d-76bb-846a-8db6f8ed4900.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment, all with stunning views.",
      "link": "false",
      "alt_text": "Modern fitness center with cardio machines, weight machines, and large windows overlooking greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/92kaSHstTr8fANdeHLavq_za-az9w_5wLCyoYLkS2Pk/102/image.jpg"
    },
    {
      "id": "ec_8d3f92a6c7486598a7e92280",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-89fd-7600-ae8e-10ef132b5097.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with weight machines, free weights, and cardio equipment.",
        "public_id": "01a03e5d-89fd-7600-ae8e-10ef132b5097",
        "storage_key": "property/6767906449167739/01a03e5d-89fd-7600-ae8e-10ef132b5097.webp",
        "width": 2048,
        "height": 1558
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight training and cardio equipment, perfect for maintaining your active lifestyle.",
      "link": "false",
      "alt_text": "Modern apartment gym with weight machines, free weights, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/H-BOUCZxZN-XgOSNLXbnm_EmENS0NJnteEyLHCSgenk/111/image.jpg"
    },
    {
      "id": "ec_04cb8580d040b4470984cbe0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-3194-7519-ac06-bc809cb5db84.webp",
      "image_media": {
        "alt_text": "Modern living room with city view at dusk",
        "public_id": "01a03e5d-3194-7519-ac06-bc809cb5db84",
        "storage_key": "property/6767906449167739/01a03e5d-3194-7519-ac06-bc809cb5db84.webp",
        "width": 2048,
        "height": 1303
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large sectional sofa, stylish coffee tables, and floor-to-ceiling windows with a stunning city skyline view at sunset.",
      "link": "false",
      "alt_text": "Modern living room with city view at dusk",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yiogyxZ9_Q3AoVvX0ArkH0Cu6DZgMlP-z__Gx5miaf8/102/image.jpg"
    },
    {
      "id": "ec_95b1565b3b7308917fac22ae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-2169-7095-ac0d-100a9529b4ff.webp",
      "image_media": {
        "alt_text": "Luxurious communal dining area with a long granite table, modern pendant lights, and city views at sunset.",
        "public_id": "01a03e5d-2169-7095-ac0d-100a9529b4ff",
        "storage_key": "property/6767906449167739/01a03e5d-2169-7095-ac0d-100a9529b4ff.webp",
        "width": 2048,
        "height": 1337
      },
      "title": "Community",
      "description": "Host your next event in this stunning communal dining space, perfect for gatherings and celebrations, featuring elegant decor and panoramic city views.",
      "link": "false",
      "alt_text": "Luxurious communal dining area with a long granite table, modern pendant lights, and city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/boe24bQrg8ZpZar4oNHgODw3ZBtcm2sY0VNFPkScBrU/110/image.jpg"
    },
    {
      "id": "ec_261834b9f63c05d63104b2d4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-980a-766e-ac77-890a3fb34af3.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and lounge area with bar seating, a large island, and comfortable seating.",
        "public_id": "01a03e5d-980a-766e-ac77-890a3fb34af3",
        "storage_key": "property/6767906449167739/01a03e5d-980a-766e-ac77-890a3fb34af3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a stylish and functional communal kitchen and lounge area, perfect for socializing or working. Features include a large island, bar seating, and comfortable lounge areas with city views.",
      "link": "false",
      "alt_text": "Modern communal kitchen and lounge area with bar seating, a large island, and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jWhzSlzhz_NzkdejRfY6PF6739eXdrjq7XFbT4YRgo0/119/image.jpg"
    },
    {
      "id": "ec_b99408db599b555997769c73",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-9d5f-74a8-97d1-e244340cee39.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace, TV, and bar.",
        "public_id": "01a03e5d-9d5f-74a8-97d1-e244340cee39",
        "storage_key": "property/6767906449167739/01a03e5d-9d5f-74a8-97d1-e244340cee39.webp",
        "width": 2048,
        "height": 1325
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a sleek fireplace, entertainment center, and a fully equipped bar.",
      "link": "false",
      "alt_text": "Modern lounge area with fireplace, TV, and bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/E3sKupeqZnpF9JJqDuCuldJoP8SsPMYNx4KlOVvoIxk/110/image.jpg"
    },
    {
      "id": "ec_82c69267d9836233bca78878",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-a31d-70da-8d53-00c3f796d84c.webp",
      "image_media": {
        "alt_text": "City skyline at night with illuminated buildings and highway traffic.",
        "public_id": "01a03e5d-a31d-70da-8d53-00c3f796d84c",
        "storage_key": "property/6767906449167739/01a03e5d-a31d-70da-8d53-00c3f796d84c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant city life from our apartments. Enjoy stunning night views of the skyline and easy access to major highways.",
      "link": "false",
      "alt_text": "City skyline at night with illuminated buildings and highway traffic.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NnYnSInyJ5tM9A_Pu9EA_iwvbDWzZjgQsVFEqCkaP84/119/image.jpg"
    },
    {
      "id": "ec_2e7904bc5b18b73ee10e1348",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-a8ed-7729-8bb5-34ba44f65562.webp",
      "image_media": {
        "alt_text": "Atlanta skyline reflected in a lake at sunrise with lush green trees in the foreground.",
        "public_id": "01a03e5d-a8ed-7729-8bb5-34ba44f65562",
        "storage_key": "property/6767906449167739/01a03e5d-a8ed-7729-8bb5-34ba44f65562.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Experience the vibrant city life with a stunning Atlanta skyline view, perfectly reflected in a serene lake. Enjoy the tranquility of nature and the energy of the city.",
      "link": "false",
      "alt_text": "Atlanta skyline reflected in a lake at sunrise with lush green trees in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YPlP6tbCy8JTX94kfAIdGnjup0WCTwcWX-9tzOHgB20/110/image.jpg"
    },
    {
      "id": "ec_43981c208b0eac3049af53d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-a633-76b9-98b0-65c48bc1f5f3.webp",
      "image_media": {
        "alt_text": "A smiling couple is served coffee by a barista.",
        "public_id": "01a03e5d-a633-76b9-98b0-65c48bc1f5f3",
        "storage_key": "property/6767906449167739/01a03e5d-a633-76b9-98b0-65c48bc1f5f3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Lifestyle",
      "description": "A happy couple enjoys coffee at a local cafe, served by a friendly barista.",
      "link": "false",
      "alt_text": "A smiling couple is served coffee by a barista.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TWeO8xE7oF9fY_0VL2A1-C7Bu4-6P2iin_3vHqCXNR8/119/image.jpg"
    },
    {
      "id": "ec_058313b860295711f30be0a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-b0c4-740e-995f-15731b60f8b0.webp",
      "image_media": {
        "alt_text": "An orchestra plays in a dimly lit concert hall, musicians reading sheet music under lamps.",
        "public_id": "01a03e5d-b0c4-740e-995f-15731b60f8b0",
        "storage_key": "property/6767906449167739/01a03e5d-b0c4-740e-995f-15731b60f8b0.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Lifestyle",
      "description": "Immerse yourself in the vibrant atmosphere of a live orchestral performance. Our community offers a rich cultural experience, perfect for those who appreciate the arts.",
      "link": "false",
      "alt_text": "An orchestra plays in a dimly lit concert hall, musicians reading sheet music under lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uc-aitHI47W1g4TAOqgMgP7Te95IjhU0tw_IRcjsEoM/110/image.jpg"
    },
    {
      "id": "ec_c6e1a8b3dd63381479d8928d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-bb59-7608-ae64-6d30f9963948.webp",
      "image_media": {
        "alt_text": "Friends enjoying a dinner party with wine.",
        "public_id": "01a03e5d-bb59-7608-ae64-6d30f9963948",
        "storage_key": "property/6767906449167739/01a03e5d-bb59-7608-ae64-6d30f9963948.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Lifestyle",
      "description": "A group of friends gathered for an intimate dinner party, sharing laughter and good conversation over wine, embodying a vibrant social lifestyle.",
      "link": "false",
      "alt_text": "Friends enjoying a dinner party with wine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3RjUDLeyzkRlrQQrtCnMfdHYXHajPUwivsMeezElVHw/119/image.jpg"
    },
    {
      "id": "ec_79e9d803c82a2ca51f7b042b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-c6ea-759e-9553-340f1bc66a1b.webp",
      "image_media": {
        "alt_text": "Nighttime view of a city skyline with fireworks over a stadium.",
        "public_id": "01a03e5d-c6ea-759e-9553-340f1bc66a1b",
        "storage_key": "property/6767906449167739/01a03e5d-c6ea-759e-9553-340f1bc66a1b.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant energy of the city with stunning fireworks displays and a lively urban atmosphere.",
      "link": "false",
      "alt_text": "Nighttime view of a city skyline with fireworks over a stadium.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k0UIDNOA1XemVRIwVSdDjGRKas5Fl0al90SY-R5CqE4/110/image.jpg"
    },
    {
      "id": "ec_1ea0c23fe1ace3788d0f0302",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-c2a1-746d-90b5-6a2041662ba0.webp",
      "image_media": {
        "alt_text": "Nighttime view of a city skyline with illuminated skyscrapers and a highway.",
        "public_id": "01a03e5d-c2a1-746d-90b5-6a2041662ba0",
        "storage_key": "property/6767906449167739/01a03e5d-c2a1-746d-90b5-6a2041662ba0.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant energy of the city from our prime location. Enjoy stunning skyline views and easy access to everything.",
      "link": "false",
      "alt_text": "Nighttime view of a city skyline with illuminated skyscrapers and a highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mxVg14WeK5FmpYYQ6cZ_8S_HEL4lDoUa9FNxYMamEys/119/image.jpg"
    },
    {
      "id": "ec_5f35178a667262af13153e31",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-c6fd-7459-bb29-5cb4f70b8229.webp",
      "image_media": {
        "alt_text": "Nighttime view of a city skyline with illuminated skyscrapers and traffic.",
        "public_id": "01a03e5d-c6fd-7459-bb29-5cb4f70b8229",
        "storage_key": "property/6767906449167739/01a03e5d-c6fd-7459-bb29-5cb4f70b8229.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Experience the vibrant city life from your apartment. Enjoy stunning skyline views and easy access to the city's attractions.",
      "link": "false",
      "alt_text": "Nighttime view of a city skyline with illuminated skyscrapers and traffic.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hxhj9zsneHuAxsSKNK0GxYBi7uRVyRKw5ySrUI-wYDE/110/image.jpg"
    },
    {
      "id": "ec_84cd7a11c5b081c3e7559e66",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-e1fb-7644-a4c3-b95d626e265c.webp",
      "image_media": {
        "alt_text": "Exterior of a modern white building with a ramp and walkway.",
        "public_id": "01a03e5d-e1fb-7644-a4c3-b95d626e265c",
        "storage_key": "property/6767906449167739/01a03e5d-e1fb-7644-a4c3-b95d626e265c.webp",
        "width": 870,
        "height": 580
      },
      "title": "Community",
      "description": "Showcasing the modern architecture of the building's exterior with a clear blue sky above.",
      "link": "false",
      "alt_text": "Exterior of a modern white building with a ramp and walkway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/M0Mq5TiqiRSAz0lQ8t12Z-xizyuIc2r7BSnBjKMKXOo/119/image.jpg"
    },
    {
      "id": "ec_c4ae95e4ebfc277db3d73582",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-cd1f-704e-bede-238c3d7459ad.webp",
      "image_media": {
        "alt_text": "Large colorful letters spelling out MIDTOWN.",
        "public_id": "01a03e5d-cd1f-704e-bede-238c3d7459ad",
        "storage_key": "property/6767906449167739/01a03e5d-cd1f-704e-bede-238c3d7459ad.webp",
        "width": 1200,
        "height": 628
      },
      "title": "Community",
      "description": "Iconic, vibrant MIDTOWN letters on a sunny day, showcasing the heart of the city's urban core.",
      "link": "false",
      "alt_text": "Large colorful letters spelling out MIDTOWN.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/xnlEOvPFfuN_qyLF06fFQjwLXB8K8RmXI_R6yMU90M4/110/image.jpg"
    },
    {
      "id": "ec_d57a112d23e47056d1c3b3a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-de71-77ac-91ab-e27e71e2a37a.webp",
      "image_media": {
        "alt_text": "Atlanta skyline at dusk with modern apartment buildings.",
        "public_id": "01a03e5d-de71-77ac-91ab-e27e71e2a37a",
        "storage_key": "property/6767906449167739/01a03e5d-de71-77ac-91ab-e27e71e2a37a.webp",
        "width": 1731,
        "height": 1155
      },
      "title": "Community",
      "description": "Experience urban living in the heart of Atlanta with stunning skyline views from our modern apartment community.",
      "link": "false",
      "alt_text": "Atlanta skyline at dusk with modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dk5MYGgGtMmztXX6mQZKyT2ZrMFQgYrMcfNVV0tEX68/119/image.jpg"
    },
    {
      "id": "ec_de42594687b6d1540489c119",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-e958-7653-8155-09b0ee46a5f9.webp",
      "image_media": {
        "alt_text": "Atlanta skyline at dusk with stadium and highway.",
        "public_id": "01a03e5d-e958-7653-8155-09b0ee46a5f9",
        "storage_key": "property/6767906449167739/01a03e5d-e958-7653-8155-09b0ee46a5f9.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Panoramic view of the Atlanta skyline at dusk, showcasing the stadium, high-rise buildings, and a busy highway with light trails.",
      "link": "false",
      "alt_text": "Atlanta skyline at dusk with stadium and highway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UDj4emcptbf2tOIC3ygoQhhWCVcq8eiVVbAk7b9gjwc/110/image.jpg"
    },
    {
      "id": "ec_96dc8f129340a07605c2ba40",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-e1af-75be-af0e-342467f2f279.webp",
      "image_media": {
        "alt_text": "Waterfront view of apartment buildings with a city skyline in the background.",
        "public_id": "01a03e5d-e1af-75be-af0e-342467f2f279",
        "storage_key": "property/6767906449167739/01a03e5d-e1af-75be-af0e-342467f2f279.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy the serene waterfront views and the vibrant city skyline that surrounds our community. A perfect blend of nature and urban living.",
      "link": "false",
      "alt_text": "Waterfront view of apartment buildings with a city skyline in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cPY8L0zjyC3h9u4WVAxki4t4lCicTzA0yfRI-qQ_Gns/119/image.jpg"
    },
    {
      "id": "ec_191b8a914545d67c562900b0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-e57c-73f5-ba88-8201e6f004cd.webp",
      "image_media": {
        "alt_text": "Modern apartment with a barn door leading to a bathroom and closet.",
        "public_id": "01a03e5d-e57c-73f5-ba88-8201e6f004cd",
        "storage_key": "property/6767906449167739/01a03e5d-e57c-73f5-ba88-8201e6f004cd.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment featuring a sleek barn door that opens to a modern bathroom and convenient closet space. The bedroom area offers a comfortable retreat with contemporary decor.",
      "link": "false",
      "alt_text": "Modern apartment with a barn door leading to a bathroom and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pzEHt60xr6IAXIORs1fg0sCGJyPoxuAz-kv25OnUmpw/110/image.jpg"
    },
    {
      "id": "ec_4c580750c1499d5ce88f3a1c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-f3eb-7290-994e-0cacd5cec19f.webp",
      "image_media": {
        "alt_text": "Modern lobby with geometric wall art, wood accents, a reception desk, and an elevator.",
        "public_id": "01a03e5d-f3eb-7290-994e-0cacd5cec19f",
        "storage_key": "property/6767906449167739/01a03e5d-f3eb-7290-994e-0cacd5cec19f.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Experience the elegant design of our community lobby, featuring unique geometric artwork, warm wood finishes, a sophisticated reception area, and convenient elevator access.",
      "link": "false",
      "alt_text": "Modern lobby with geometric wall art, wood accents, a reception desk, and an elevator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uJS3sgFnBSIsn3acPg--sN_-QbWjn5e_5U_XGRsnOrc/119/image.jpg"
    },
    {
      "id": "ec_3e153f7c54425d73b551199f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-f9cb-7348-b4e9-010bd09761c8.webp",
      "image_media": {
        "alt_text": "Modern apartment bedroom with a large bed, desk, and city view.",
        "public_id": "01a03e5d-f9cb-7348-b4e9-010bd09761c8",
        "storage_key": "property/6767906449167739/01a03e5d-f9cb-7348-b4e9-010bd09761c8.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this stylish apartment bedroom, featuring a plush bed, a dedicated workspace, and expansive city views.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a large bed, desk, and city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/26r3jl99ff4Uv-s4GNGt35xHvh-wvJ6fx6sWQDsWTQY/110/image.jpg"
    },
    {
      "id": "ec_d737ad293df6cc33ba780daf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5d-ff57-761b-80d4-8c3eef279911.webp",
      "image_media": {
        "alt_text": "Modern community lounge with island, bar seating, and abstract wall art.",
        "public_id": "01a03e5d-ff57-761b-80d4-8c3eef279911",
        "storage_key": "property/6767906449167739/01a03e5d-ff57-761b-80d4-8c3eef279911.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a contemporary kitchen island, bar seating, and unique accent lighting.",
      "link": "false",
      "alt_text": "Modern community lounge with island, bar seating, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/kduV8-eY-vuwXeDTrbe_iWvIdEb-_uqSNGo0kCEwQcg/119/image.jpg"
    },
    {
      "id": "ec_c04b22b16a2a478d57786882",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5e-0281-70ec-97f7-de65cdb2e47c.webp",
      "image_media": {
        "alt_text": "A modern lounge area with a bar, seating, and a pizza oven.",
        "public_id": "01a03e5e-0281-70ec-97f7-de65cdb2e47c",
        "storage_key": "property/6767906449167739/01a03e5e-0281-70ec-97f7-de65cdb2e47c.webp",
        "width": 2048,
        "height": 1171
      },
      "title": "Community",
      "description": "Experience our chic lounge area, complete with a full-service bar, comfortable seating, and a unique pizza oven. Perfect for socializing and unwinding.",
      "link": "false",
      "alt_text": "A modern lounge area with a bar, seating, and a pizza oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vMAbV2MOgqrAx6VlLL_ZRjPEwlwjfe9Te-ZY-dqzYfg/110/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_9a25c5bbe1f82f712410e141",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "South City Kitchen Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1144 Crescent Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_long_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-d08c-7012-a328-4777330cb93a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d08c-7012-a328-4777330cb93a",
        "storage_key": "property/6767906449167739/01a03e5b-d08c-7012-a328-4777330cb93a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.southcitykitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11724931360973815545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-city-kitchen-midtown",
      "poi_latitude": "33.7859545",
      "poi_longitude": "-84.3844341",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-873-7358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQqtX0ME9YgR-X6ukvNSt6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_cff3f1e24c6c04c1ab0c0367",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Café Intermezzo - Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1065 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "European-style coffeehouse offering many beverages & pastries, plus crêpes & sandwiches.",
      "poi_long_description": "European-style coffeehouse offering many beverages & pastries, plus crêpes & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-b422-758b-b21f-9a8989329f44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b422-758b-b21f-9a8989329f44",
        "storage_key": "property/6767906449167739/01a03e5b-b422-758b-b21f-9a8989329f44.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cafeintermezzo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2132681066176294857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-intermezzo---midtown",
      "poi_latitude": "33.7832371",
      "poi_longitude": "-84.3836022",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-355-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9c0c-735b-9c47-164d27dc875d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9c0c-735b-9c47-164d27dc875d",
        "storage_key": "property/6767906449167739/01a03e5c-9c0c-735b-9c47-164d27dc875d.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJicBn_aoF9YgRya-jWCHOmB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_03b8937d1be267b4a37bfbc6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Ray's New York Pizza",
      "poi_type": "Restaurants",
      "poi_address": "26 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_long_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-c0f4-741e-b2a2-ae6b00f2e923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c0f4-741e-b2a2-ae6b00f2e923",
        "storage_key": "property/6767906449167739/01a03e5b-c0f4-741e-b2a2-ae6b00f2e923.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.raysnewyorkpizza.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=15318366614929564075",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135719434802151797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-new-york-pizza",
      "poi_latitude": "33.7766683",
      "poi_longitude": "-84.3882138",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-888-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0OaXmYE9YgRdcEDP2yYyH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_1ec3d7ccf203b6e556882040",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Ecco Midtown",
      "poi_type": "Restaurants",
      "poi_address": "40 7th St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_long_description": "Sleek spot for an ever-changing menu of seasonally inspired Continental fare & a bustling bar scene.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-ba4a-7392-953e-c0e896683309.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-ba4a-7392-953e-c0e896683309",
        "storage_key": "property/6767906449167739/01a03e5b-ba4a-7392-953e-c0e896683309.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.ecco-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615100838986662872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecco-midtown",
      "poi_latitude": "33.7787559",
      "poi_longitude": "-84.38584410000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-347-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyVS2WcE9YgR2EM86Kf9aRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_73616a3f3a7148832f0aa84c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Nan Thai Fine Dining",
      "poi_type": "Restaurants",
      "poi_address": "1350 Spring St NW #1, Atlanta, GA 30309, USA",
      "poi_short_description": "Classy Thai restaurant offering upscale eats & modern, Zenlike interior design.",
      "poi_long_description": "Classy Thai restaurant offering upscale eats & modern, Zenlike interior design.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-b1ac-72c9-88cb-6089ef9024d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b1ac-72c9-88cb-6089ef9024d1",
        "storage_key": "property/6767906449167739/01a03e5b-b1ac-72c9-88cb-6089ef9024d1.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://nanfinedining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9460521279060453574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nan-thai-fine-dining",
      "poi_latitude": "33.791638",
      "poi_longitude": "-84.389488",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-870-9933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4_nc1oE9YgRxihstPqFSoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_4e3adba02159f94d84d90d43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Cypress Street Pint & Plate",
      "poi_type": "Restaurants",
      "poi_address": "817 W Peachtree St NW a180, Atlanta, GA 30308, USA",
      "poi_short_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_long_description": "A rotating lineup of beers on tap pairs with hearty American grub at a relaxed tavern with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-bc49-753f-9c11-75e1e8b4f8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bc49-753f-9c11-75e1e8b4f8bb",
        "storage_key": "property/6767906449167739/01a03e5b-bc49-753f-9c11-75e1e8b4f8bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cypressatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5004059078031367358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-street-pint--plate",
      "poi_latitude": "33.7773253",
      "poi_longitude": "-84.38614559999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-815-9243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9c18-77d6-992d-c21651c8254d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9c18-77d6-992d-c21651c8254d",
        "storage_key": "property/6767906449167739/01a03e5c-9c18-77d6-992d-c21651c8254d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJweczQWYE9YgRvtwgBTj9cUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_a859012395ad605d26aa800b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "The Consulate Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10 10th St NW Ste P200, Atlanta, GA 30309, USA",
      "poi_short_description": "Rotating international small plates menu served in a lush, retro space with a stylish full bar.",
      "poi_long_description": "Rotating international small plates menu served in a lush, retro space with a stylish full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-bcec-7444-bd09-441a4e823ba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-bcec-7444-bd09-441a4e823ba8",
        "storage_key": "property/6767906449167739/01a03e5b-bcec-7444-bd09-441a4e823ba8.webp",
        "width": 1280,
        "height": 781
      },
      "poi_business_url": "http://www.theconsulateatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15881603152788312066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-consulate-restaurant",
      "poi_latitude": "33.781862",
      "poi_longitude": "-84.3866219",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-254-5760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmxSlaV0E9YgRAtCrUezJZtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_f21f7a34b6d09422fa2865de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Lyla Lila",
      "poi_type": "Restaurants",
      "poi_address": "693 Peachtree St NE Unit 118, Atlanta, GA 30308, USA",
      "poi_short_description": "Upscale restaurant with a trendy vibe serving up southern European fare, including pasta & seafood.",
      "poi_long_description": "Upscale restaurant with a trendy vibe serving up southern European fare, including pasta & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-c0e4-73f9-ad9b-6710538e1e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-c0e4-73f9-ad9b-6710538e1e06",
        "storage_key": "property/6767906449167739/01a03e5b-c0e4-73f9-ad9b-6710538e1e06.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.lylalilaatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13933689576621309154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lyla-lila",
      "poi_latitude": "33.7735507",
      "poi_longitude": "-84.3846361",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-963-2637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_3PrTsF9YgR4nwTmdhoXsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ae129bb73a03943dbe2cf19d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "The Vortex Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "878 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_long_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-b7e2-76a2-b764-8efe53d849dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b7e2-76a2-b764-8efe53d849dd",
        "storage_key": "property/6767906449167739/01a03e5b-b7e2-76a2-b764-8efe53d849dd.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thevortexbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2105728285314260711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vortex-bar--grill",
      "poi_latitude": "33.7790602",
      "poi_longitude": "-84.3844407",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-875-1667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-icamgE9YgR5x6mB7gMOR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_26dc4145f4c4adf8ef415141",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Livingston Restaurant + Bar",
      "poi_type": "Restaurants",
      "poi_address": "659 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Innovative American cuisine is served amid modern elegance at the historic Georgian Terrace Hotel.",
      "poi_long_description": "Innovative American cuisine is served amid modern elegance at the historic Georgian Terrace Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-b5ac-773c-83d5-06dc32701338.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-b5ac-773c-83d5-06dc32701338",
        "storage_key": "property/6767906449167739/01a03e5b-b5ac-773c-83d5-06dc32701338.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://www.livingstonatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5520599113451930707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-restaurant--bar",
      "poi_latitude": "33.7724239",
      "poi_longitude": "-84.38473359999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-897-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_xUc28E9YgRU4Sj8KQbnUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9dbde29a20b3031dae654b71",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "White Windmill Bakery & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1331 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-ce8e-7619-9571-ad35bb192f57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-ce8e-7619-9571-ad35bb192f57",
        "storage_key": "property/6767906449167739/01a03e5b-ce8e-7619-9571-ad35bb192f57.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.whitewbakerycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11288773099995012024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-windmill-bakery--cafe",
      "poi_latitude": "33.7911962",
      "poi_longitude": "-84.3885291",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 770-209-2557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3FxAgAF9YgRuBsw71LHqZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_b25edac4e47ae0cd5e81ef64",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "The Varsity",
      "poi_type": "Restaurants",
      "poi_address": "61 North Ave NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Long-running drive-in chain serving up burgers, hot dogs, fries, shakes & other American classics.",
      "poi_long_description": "Long-running drive-in chain serving up burgers, hot dogs, fries, shakes & other American classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e58-e620-777a-887d-81a4bc45a76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-e620-777a-887d-81a4bc45a76d",
        "storage_key": "property/6767906449167739/01a03e58-e620-777a-887d-81a4bc45a76d.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://thevarsity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16355400820245921208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-varsity",
      "poi_latitude": "33.7715946",
      "poi_longitude": "-84.3893032",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-881-1706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWUM7mQE9YgRuP3jMWQO-uI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_7b604171c55f11ea7db23ad5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Poor Calvin's",
      "poi_type": "Restaurants",
      "poi_address": "510 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Modern, intimate eatery featuring an Asian fusion menu plus both classic and creative cocktails.",
      "poi_long_description": "Modern, intimate eatery featuring an Asian fusion menu plus both classic and creative cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-d277-7692-b3d5-c3384ada0934.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d277-7692-b3d5-c3384ada0934",
        "storage_key": "property/6767906449167739/01a03e5b-d277-7692-b3d5-c3384ada0934.webp",
        "width": 1280,
        "height": 695
      },
      "poi_business_url": "http://www.poorcalvins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537587445608299274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poor-calvins",
      "poi_latitude": "33.7684665",
      "poi_longitude": "-84.3822003",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-254-4051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWNQxHEE9YgRCjuVoqKbVhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_c850876889c62a239d306e18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Mary Mac's Tea Room",
      "poi_type": "Restaurants",
      "poi_address": "224 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "This 1945-era institution draws locals & tourists for Southern comfort food in a homey space.",
      "poi_long_description": "This 1945-era institution draws locals & tourists for Southern comfort food in a homey space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-d53b-7746-88cf-f3f3be1583d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d53b-7746-88cf-f3f3be1583d5",
        "storage_key": "property/6767906449167739/01a03e5b-d53b-7746-88cf-f3f3be1583d5.webp",
        "width": 1080,
        "height": 1280
      },
      "poi_business_url": "http://www.marymacs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14428011323645827231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-macs-tea-room",
      "poi_latitude": "33.7728043",
      "poi_longitude": "-84.3798348",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-876-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUolJWwE9YgRnxg5IduXOsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d8b22b3ad19bac718bf9330e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Politan Row at Colony Square",
      "poi_type": "Restaurants",
      "poi_address": "1197 Peachtree St NE Apt 150, Atlanta, GA 30361, USA",
      "poi_short_description": "A casual food hall with vendors serving pizza, banh mi, ramen and tacos, plus two bars.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-df5f-74bc-b6e1-869c6749c9b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-df5f-74bc-b6e1-869c6749c9b1",
        "storage_key": "property/6767906449167739/01a03e5b-df5f-74bc-b6e1-869c6749c9b1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://colonysquare.politanrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2160757304249077191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "politan-row-at-colony-square",
      "poi_latitude": "33.7871256",
      "poi_longitude": "-84.3821143",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-228-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizzK5GkF9YgRx82Y7VGN_B0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_842d8789cc75c084110a92b1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 14th St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-d84b-7461-a76c-9eb5ea53667e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-d84b-7461-a76c-9eb5ea53667e",
        "storage_key": "property/6767906449167739/01a03e5b-d84b-7461-a76c-9eb5ea53667e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/midtownatlanta?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001220",
      "poi_directions_map_url": "https://maps.google.com/?cid=347012611710925997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.7862472",
      "poi_longitude": "-84.38875569999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-552-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a52-772a-be4d-89b8d591d755",
        "storage_key": "property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xL51kwF9YgRrTycvSHW0AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_96bd68d9706b4ec2fc0aa63f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Publix Super Market at The Plaza Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "950 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-dfd7-70b9-aba2-6ac5147c7508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-dfd7-70b9-aba2-6ac5147c7508",
        "storage_key": "property/6767906449167739/01a03e5b-dfd7-70b9-aba2-6ac5147c7508.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1061&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3963935707884851565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-plaza-midtown",
      "poi_latitude": "33.7804802",
      "poi_longitude": "-84.388809",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-253-3544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a52-772a-be4d-89b8d591d755",
        "storage_key": "property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTK9iWcE9YgRbZH2RIa6Ajc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_545987e037a9f32cdb1acb06",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "842 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-df6b-77da-b0a5-339cd1c4e055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-df6b-77da-b0a5-339cd1c4e055",
        "storage_key": "property/6767906449167739/01a03e5b-df6b-77da-b0a5-339cd1c4e055.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/842-peachtree-street-ne-atlanta-ga-30308/storeid=2943?WT.mc_id=LS_GOOGLE_FS_2943",
      "poi_directions_map_url": "https://maps.google.com/?cid=15933037119015621559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7774986",
      "poi_longitude": "-84.3845652",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-892-8468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwRLxGIF9YgRtxMKyNeEHd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_f2237116090a6ba49ff71f26",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE Ste 100, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-e982-733a-8408-d95d322d0b12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-e982-733a-8408-d95d322d0b12",
        "storage_key": "property/6767906449167739/01a03e5b-e982-733a-8408-d95d322d0b12.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-595+piedmont+ave+ne-atlanta-ga-30308/id=6032",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791041622720626702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.770849",
      "poi_longitude": "-84.381102",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-685-9665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9c12-75a8-9145-c53d458e64e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9c12-75a8-9145-c53d458e64e5",
        "storage_key": "property/6767906449167739/01a03e5c-9c12-75a8-9145-c53d458e64e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRGnEm4E9YgRDsC3ti57wZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_fde34cc88a6a35b644a213c1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "931 Monroe Dr NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e58-eb87-7573-9a20-5aa13157a3d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-eb87-7573-9a20-5aa13157a3d6",
        "storage_key": "property/6767906449167739/01a03e58-eb87-7573-9a20-5aa13157a3d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ga/atlanta/730/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11864546698858430255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.7797402",
      "poi_longitude": "-84.3676474",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-815-9210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a52-772a-be4d-89b8d591d755",
        "storage_key": "property/6767906449167739/01a03e5a-9a52-772a-be4d-89b8d591d755.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zoUGxYE9YgRL399jlxWp6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0f155d62406d224a91b10dc6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_long_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e58-eab3-7058-a92c-21cb78bc03ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-eab3-7058-a92c-21cb78bc03ae",
        "storage_key": "property/6767906449167739/01a03e58-eab3-7058-a92c-21cb78bc03ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://poncecitymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460613837555701121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ponce-city-market",
      "poi_latitude": "33.7727683",
      "poi_longitude": "-84.3655967",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-900-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a4c-7173-833a-af2373de80bc",
        "storage_key": "property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTTv9ohAE9YgRgRWbbatrrsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e908b6bc90b9ff97ec4672bb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Midtown Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "650 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Shopping center with Whole Foods and T.J. Maxx, plus a range of other stores.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-03a7-71b2-a4df-95d73293faad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-03a7-71b2-a4df-95d73293faad",
        "storage_key": "property/6767906449167739/01a03e5c-03a7-71b2-a4df-95d73293faad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cororealtyadvisors.propertycapsule.com/properties/midtownplaceshoppingcenter#photos",
      "poi_directions_map_url": "https://maps.google.com/?cid=2216968853067102892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-place",
      "poi_latitude": "33.7755758",
      "poi_longitude": "-84.36623879999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-846-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a4c-7173-833a-af2373de80bc",
        "storage_key": "property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw5PzdDoF9YgRrHorBW1BxB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e7182731c6ca6db4f1b43c5d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Colony Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1197 Peachtree St NE, Atlanta, GA 30361, USA",
      "poi_short_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_long_description": "Mixed-use complex featuring professional offices, shops, services, restaurants & frequent events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-f93d-722d-a638-3d2a4df9bbd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f93d-722d-a638-3d2a4df9bbd8",
        "storage_key": "property/6767906449167739/01a03e5b-f93d-722d-a638-3d2a4df9bbd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colonysquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2240213496914822969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colony-square",
      "poi_latitude": "33.7873463",
      "poi_longitude": "-84.38246629999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-965-9091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a4c-7173-833a-af2373de80bc",
        "storage_key": "property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgbZHQ0QE9YgROcekaE7WFh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_274fe69a0452c1b3ba7aefe5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Atlantic Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1380 Atlantic Dr NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_long_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-f85e-715f-bcbc-43f0fe7ef6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f85e-715f-bcbc-43f0fe7ef6a5",
        "storage_key": "property/6767906449167739/01a03e5b-f85e-715f-bcbc-43f0fe7ef6a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atlanticstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075264230802959861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-station",
      "poi_latitude": "33.79249830000001",
      "poi_longitude": "-84.39651820000002",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-410-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a4c-7173-833a-af2373de80bc",
        "storage_key": "property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk8PKSvYE9YgR9a2Nw6XPFt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_027bff415b5318b09ca73429",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "375 18th St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-f1bc-72a6-9120-f6c369e2f910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f1bc-72a6-9120-f6c369e2f910",
        "storage_key": "property/6767906449167739/01a03e5b-f1bc-72a6-9120-f6c369e2f910.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/atlanta-midtown/2137",
      "poi_directions_map_url": "https://maps.google.com/?cid=3536171801797396388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.7932856",
      "poi_longitude": "-84.39933669999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-954-4265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a4c-7173-833a-af2373de80bc",
        "storage_key": "property/6767906449167739/01a03e5a-9a4c-7173-833a-af2373de80bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtz7EAvgE9YgRpAfjroQBEzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_985ef649eafffc7754fed7c6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-fd05-7271-a524-84cdd5751c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-fd05-7271-a524-84cdd5751c08",
        "storage_key": "property/6767906449167739/01a03e5b-fd05-7271-a524-84cdd5751c08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_438724dac73e511a227e60fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "David T. Howard Middle School",
      "poi_type": "Education",
      "poi_address": "551 John Wesley Dobbs Ave NE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-0eb0-7236-bdfa-e017f7cc3544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0eb0-7236-bdfa-e017f7cc3544",
        "storage_key": "property/6767906449167739/01a03e5c-0eb0-7236-bdfa-e017f7cc3544.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://howard.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7462350126577969402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-t-howard-middle-school",
      "poi_latitude": "33.7587659",
      "poi_longitude": "-84.3687987",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-802-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA4ihuAkE9YgR-mhFJOeXj2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_4b635012fa71ac30d74febb9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Virginia Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "774 Virginia Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://virginiahighland.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585150837372331685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-highland-elementary-school",
      "poi_latitude": "33.7818981",
      "poi_longitude": "-84.3621988",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-802-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJTmyeiIF9YgRpaaNXhhxgk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_fd1076b95889795d86edbed1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Weinberg Early Learning Center at The Temple",
      "poi_type": "Education",
      "poi_address": "1589 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.the-temple.org/welc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14137011655365501529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weinberg-early-learning-center-at-the-temple",
      "poi_latitude": "33.7979152",
      "poi_longitude": "-84.38929040000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-872-8668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4aaqpFEE9YgRWSKeDzPBMMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_aa4828d72b8fa9ce51cfa255",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Bright Horizons at Atlantic Station",
      "poi_type": "Education",
      "poi_address": "1381 Market St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5b-f65e-76b8-ba05-82c0926c0e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5b-f65e-76b8-ba05-82c0926c0e23",
        "storage_key": "property/6767906449167739/01a03e5b-f65e-76b8-ba05-82c0926c0e23.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/ga/atlanta/1381-market-street-30363?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=1362925812386251125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-atlantic-station",
      "poi_latitude": "33.7923205",
      "poi_longitude": "-84.3945336",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-618-1709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxhbjlcE9YgRdUF-Js4V6hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_49be914983a0e90082af5586",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Bright Horizons",
      "poi_type": "Education",
      "poi_address": "1316 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-031a-715a-a203-d895c8e440c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-031a-715a-a203-d895c8e440c1",
        "storage_key": "property/6767906449167739/01a03e5c-031a-715a-a203-d895c8e440c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brighthorizons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4712645183626200027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons",
      "poi_latitude": "33.7905685",
      "poi_longitude": "-84.38818250000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-815-0023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbcw181oE9YgR28N-atOtZkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_07c5937bf19ed6eb2e1969f0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "The Children's Campus at Georgia Tech",
      "poi_type": "Education",
      "poi_address": "251 10th St NW Bldg F, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-1674-77d4-b76c-51987462b8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1674-77d4-b76c-51987462b8fd",
        "storage_key": "property/6767906449167739/01a03e5c-1674-77d4-b76c-51987462b8fd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/ga/atlanta/251-10th-street-30318?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=12436080787134707189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-campus-at-georgia-tech",
      "poi_latitude": "33.78257",
      "poi_longitude": "-84.39578929999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-437-4278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9UmqjF8E9YgR9XU5M5bVlaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d5a83c21a4bee7a3412b0925",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Dar-Un-Noor Academy",
      "poi_type": "Education",
      "poi_address": "434 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-0d35-70c8-bbb1-7cd2c7c2a307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0d35-70c8-bbb1-7cd2c7c2a307",
        "storage_key": "property/6767906449167739/01a03e5c-0d35-70c8-bbb1-7cd2c7c2a307.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.darunnoor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17647756409139953827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dar-un-noor-academy",
      "poi_latitude": "33.7855612",
      "poi_longitude": "-84.4010402",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-876-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnVCaCPQE9YgRowBpyfNs6fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_740bc1180c24b7ae365d3cc7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Centennial Academy Charter School",
      "poi_type": "Education",
      "poi_address": "531 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-05ac-739d-b9c9-a989965537a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-05ac-739d-b9c9-a989965537a5",
        "storage_key": "property/6767906449167739/01a03e5c-05ac-739d-b9c9-a989965537a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.centennialacademycharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758874460627942836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-academy-charter-school",
      "poi_latitude": "33.7696876",
      "poi_longitude": "-84.39518009999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-802-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJATHnVH0E9YgRtD0kUAXqL6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_354801680e0ec18f24d25203",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology-Dean's Office",
      "poi_type": "Education",
      "poi_address": "225 North Ave NW #202, Atlanta, GA 30332, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-0919-7418-a3b2-6ff757bf0bc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-0919-7418-a3b2-6ff757bf0bc5",
        "storage_key": "property/6767906449167739/01a03e5c-0919-7418-a3b2-6ff757bf0bc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/about/leadership",
      "poi_directions_map_url": "https://maps.google.com/?cid=2281686728971383656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology-deans-office",
      "poi_latitude": "33.7724231",
      "poi_longitude": "-84.3947865",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-894-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfwlvi2IE9YgRaPMPuf0tqh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_f4c04058e4a31ee4fbbaa79f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Center Stage Theater",
      "poi_type": "Entertainment",
      "poi_address": "1374 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_long_description": "Intimate performing arts venue seats 1,050 with premier lighting & sound & separate lounge space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-13cc-703f-8f3d-6ee0afe7874e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-13cc-703f-8f3d-6ee0afe7874e",
        "storage_key": "property/6767906449167739/01a03e5c-13cc-703f-8f3d-6ee0afe7874e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centerstage-atlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16982912977202433654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-stage-theater",
      "poi_latitude": "33.7922155",
      "poi_longitude": "-84.3879559",
      "poi_miles_from_property": "213 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-885-1365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXLceFAE9YgRds6FmV9tr-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_1ba11d1b993abc1d61699694",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "High Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree Rd NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_long_description": "Museum known for its diverse art collection & modern architecture by Richard Meier & Renzo Piano.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-1b8f-7518-96e2-c19f8a3ceb8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1b8f-7518-96e2-c19f8a3ceb8e",
        "storage_key": "property/6767906449167739/01a03e5c-1b8f-7518-96e2-c19f8a3ceb8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.high.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827694190187609074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-museum-of-art",
      "poi_latitude": "33.7900632",
      "poi_longitude": "-84.38555199999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-733-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a16-71ab-99ab-2086a767ce7c",
        "storage_key": "property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgR8nttKmmxaPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_fa4268ea934f038d3e48d4db",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-4f19-714a-9a48-6b7ce81c52ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-4f19-714a-9a48-6b7ce81c52ef",
        "storage_key": "property/6767906449167739/01a03e59-4f19-714a-9a48-6b7ce81c52ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_87b9986b1aa5bc179d0cc542",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Center For Puppetry Arts",
      "poi_type": "Entertainment",
      "poi_address": "1404 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_long_description": "Long-standing puppetry museum with a variety of exhibits, performances, workshops & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-1b9c-72ad-a030-e84b0b9e948f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-1b9c-72ad-a030-e84b0b9e948f",
        "storage_key": "property/6767906449167739/01a03e5c-1b9c-72ad-a030-e84b0b9e948f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.puppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253606720874116330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-puppetry-arts",
      "poi_latitude": "33.792875",
      "poi_longitude": "-84.38985989999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-873-3391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a16-71ab-99ab-2086a767ce7c",
        "storage_key": "property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fRXllAE9YgR6nR6SZWzinI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_9391013f6d29d77094a5bf2a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Fox Theatre",
      "poi_type": "Entertainment",
      "poi_address": "660 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_long_description": "Restored opulent theater built in 1920s with 3,600-pipe organ hosts ballet, movies & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-25b6-74ca-9636-a4827be77337.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-25b6-74ca-9636-a4827be77337",
        "storage_key": "property/6767906449167739/01a03e5c-25b6-74ca-9636-a4827be77337.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.foxtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1917821642260137630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-theatre",
      "poi_latitude": "33.7726136",
      "poi_longitude": "-84.3853395",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-285-8499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28DQdm8E9YgRnsZ4YZ94nRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_faa9ea398442b1c3e993b4bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Alliance Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1280 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_long_description": "Acclaimed theater company featuring house productions of major plays & acting workshops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-34e9-73bd-8965-d153e472babd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-34e9-73bd-8965-d153e472babd",
        "storage_key": "property/6767906449167739/01a03e5c-34e9-73bd-8965-d153e472babd.webp",
        "width": 1280,
        "height": 1040
      },
      "poi_business_url": "http://alliancetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15996732928718111168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alliance-theatre",
      "poi_latitude": "33.7892466",
      "poi_longitude": "-84.38540859999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-733-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bUMEUE9YgRwIEJJ9jP_90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ff4de853b4c3766d5bc17d7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "SCAD FASH Museum of Fashion + Film",
      "poi_type": "Entertainment",
      "poi_address": "1600 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Spacious venue showcasing glamorous gowns & other designer garments made for the cinema.",
      "poi_long_description": "Spacious venue showcasing glamorous gowns & other designer garments made for the cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-3046-72c2-b947-3ab8e36b4462.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3046-72c2-b947-3ab8e36b4462",
        "storage_key": "property/6767906449167739/01a03e5c-3046-72c2-b947-3ab8e36b4462.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.scadfash.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17502768917205551998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scad-fash-museum-of-fashion--film",
      "poi_latitude": "33.796638",
      "poi_longitude": "-84.391256",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-253-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a16-71ab-99ab-2086a767ce7c",
        "storage_key": "property/6767906449167739/01a03e5a-9a16-71ab-99ab-2086a767ce7c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVjqs1YE9YgRfgvJt5hT5vI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_31e30c8c28144b33a6f03da0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Landmark's Midtown Art Cinema",
      "poi_type": "Entertainment",
      "poi_address": "931 Monroe Dr NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_long_description": "Movie theater screening new releases as well as independent, foreign & avant-garde flicks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-266b-72d8-b562-e7e4bf3a0efb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-266b-72d8-b562-e7e4bf3a0efb",
        "storage_key": "property/6767906449167739/01a03e5c-266b-72d8-b562-e7e4bf3a0efb.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "https://www.landmarktheatres.com/atlanta/midtown-art-cinema",
      "poi_directions_map_url": "https://maps.google.com/?cid=7135845890094996050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "landmarks-midtown-art-cinema",
      "poi_latitude": "33.779128",
      "poi_longitude": "-84.36725009999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-879-0160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9ce6-710b-862b-ecf8e117633b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9ce6-710b-862b-ecf8e117633b",
        "storage_key": "property/6767906449167739/01a03e5c-9ce6-710b-862b-ecf8e117633b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYwbERYE9YgRUhoLmweeB2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_d9f951c3fda13dc7b55d29c7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Park Tavern",
      "poi_type": "Restaurants",
      "poi_address": "500 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Rustic sports bar offering burgers, beer & a patio with park views.",
      "poi_long_description": "Rustic sports bar offering burgers, beer & a patio with park views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-3a5c-701b-ade2-355ac12e747a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3a5c-701b-ade2-355ac12e747a",
        "storage_key": "property/6767906449167739/01a03e5c-3a5c-701b-ade2-355ac12e747a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.parktavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16525377754351243922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-tavern",
      "poi_latitude": "33.7822253",
      "poi_longitude": "-84.3692889",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-249-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a0c-7741-a585-6ee1acc7eaa8",
        "storage_key": "property/6767906449167739/01a03e5a-9a0c-7741-a585-6ee1acc7eaa8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwFXzj0E9YgRkpI_K4PvVeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0ac56573701ef7d9645569dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1049 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_long_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-34e9-73bd-8965-d418000213f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-34e9-73bd-8965-d418000213f4",
        "storage_key": "property/6767906449167739/01a03e5c-34e9-73bd-8965-d418000213f4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.plazaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819026170921268730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-theatre",
      "poi_latitude": "33.7734567",
      "poi_longitude": "-84.3530406",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 470-410-1939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9ce6-710b-862b-ecf8e117633b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9ce6-710b-862b-ecf8e117633b",
        "storage_key": "property/6767906449167739/01a03e5c-9ce6-710b-862b-ecf8e117633b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP47X-6MG9YgR-rV20HhVwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_1474e86ce5d8b6cb0247cde0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Northside Medical Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1110 W Peachtree St NW, Atlanta, GA 30342, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-3952-71cb-a7fe-eb48b055c7e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3952-71cb-a7fe-eb48b055c7e2",
        "storage_key": "property/6767906449167739/01a03e5c-3952-71cb-a7fe-eb48b055c7e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.northside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13207439122071304450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-medical-midtown",
      "poi_latitude": "33.7853927",
      "poi_longitude": "-84.38816829999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-875-2640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmePxIAcF9YgRAjmoz-c_Src",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_d9152323ab5e8e43ac968530",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-336b-778d-afd1-8fbfd6ccb58c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-336b-778d-afd1-8fbfd6ccb58c",
        "storage_key": "property/6767906449167739/01a03e5c-336b-778d-afd1-8fbfd6ccb58c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9ab5-71be-bf88-031d89515c22",
        "storage_key": "property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0b9f527348449a15b45656ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-4106-754e-be9d-d658da13258d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-4106-754e-be9d-d658da13258d",
        "storage_key": "property/6767906449167739/01a03e59-4106-754e-be9d-d658da13258d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9ab5-71be-bf88-031d89515c22",
        "storage_key": "property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e8b30e179d9dd0996c85b9fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "AllCare Primary & Immediate Care: Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "805 Peachtree St NE Unit A, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4943-748d-9638-3f1f5bd4a58f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4943-748d-9638-3f1f5bd4a58f",
        "storage_key": "property/6767906449167739/01a03e5c-4943-748d-9638-3f1f5bd4a58f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.allcare-ga.com/location/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=12535664565043690199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allcare-primary--immediate-care-midtown",
      "poi_latitude": "33.7764832",
      "poi_longitude": "-84.38401979999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-779-7026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ5PE6oF9YgR13rhToGg960",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_794508ffb927b5aa524aa9a9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Piedmont QuickCare - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "595 Piedmont Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-3e4b-75d9-94dc-3f50c8a1210e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-3e4b-75d9-94dc-3f50c8a1210e",
        "storage_key": "property/6767906449167739/01a03e5c-3e4b-75d9-94dc-3f50c8a1210e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.care.piedmont.org/locations/location-details/practice/1985?utm_source=directorylisting&utm_medium=seo&utm_campaign=10221&y_source=1_MjA2MTQ5NDI2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15354154154259137251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-quickcare---midtown",
      "poi_latitude": "33.7708702",
      "poi_longitude": "-84.3811193",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-732-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAdFaHiwF9YgR40I0f9rpFNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_4ae34e4f44d8e00e924de537",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "565 Peachtree St NE Spc B, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-40a8-733d-8623-0f20f962852f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-40a8-733d-8623-0f20f962852f",
        "storage_key": "property/6767906449167739/01a03e5c-40a8-733d-8623-0f20f962852f.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-565+peachtree+st+ne-atlanta-ga-30308/id=21146",
      "poi_directions_map_url": "https://maps.google.com/?cid=15196450436197706635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "33.770088",
      "poi_longitude": "-84.3848515",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-662-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9c12-75a8-9145-c53d458e64e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9c12-75a8-9145-c53d458e64e5",
        "storage_key": "property/6767906449167739/01a03e5c-9c12-75a8-9145-c53d458e64e5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRg8z4cF9YgRi-tkUCij5NI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4ef4f972d5aab06cbdf41b2a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "CorePower Yoga - Atlanta Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "860 Peachtree St NE Suite J, Atlanta, GA 30308, USA",
      "poi_short_description": "Branch of a fitness chain offering vigorous yoga classes with a focus on mindfulness.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4c5c-769f-85dc-be208281bb8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4c5c-769f-85dc-be208281bb8e",
        "storage_key": "property/6767906449167739/01a03e5c-4c5c-769f-85dc-be208281bb8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ga/atlanta/atlanta-midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3395339368669349519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---atlanta-midtown",
      "poi_latitude": "33.7784663",
      "poi_longitude": "-84.38542319999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZUNWe2gE9YgRj4ZvoSqrHi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_49f763775e6ca5e7457ef087",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "933 Peachtree St NE #939A, Atlanta, GA 30309, USA",
      "poi_short_description": "Group, treadmill-based workout studio, featuring certified instructors and fitness training in an energetic environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4f8f-770b-a4c1-fe377c0ee78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4f8f-770b-a4c1-fe377c0ee78d",
        "storage_key": "property/6767906449167739/01a03e5c-4f8f-770b-a4c1-fe377c0ee78d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/atlanta-georgia-0137?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=621678546688391647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.780276",
      "poi_longitude": "-84.3839747",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-747-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWpDnUIE9YgR37nXK1iloAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9580bb21e5efdceb125e6d4e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-310b-766a-986b-70e73a5099af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-310b-766a-986b-70e73a5099af",
        "storage_key": "property/6767906449167739/01a03e59-310b-766a-986b-70e73a5099af.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6940819f38d977b5b9254079",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4cbb-76fb-993f-73e1de108627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4cbb-76fb-993f-73e1de108627",
        "storage_key": "property/6767906449167739/01a03e5c-4cbb-76fb-993f-73e1de108627.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_81456c7e0e8bdab485f83222",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "The Atlanta Beltline Eastside Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta Beltline Eastside Trl, Atlanta, GA 30312, USA",
      "poi_short_description": "Multiuse trail for walking, biking or jogging through the city past restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-5354-75ee-8c22-c6bb5b463f79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-5354-75ee-8c22-c6bb5b463f79",
        "storage_key": "property/6767906449167739/01a03e5c-5354-75ee-8c22-c6bb5b463f79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://beltline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7911417990981684592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-atlanta-beltline-eastside-trail",
      "poi_latitude": "33.7819037",
      "poi_longitude": "-84.36849160000001",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-546-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7N6gJcF9YgRcA0ZDr8Ay20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4c5f52e2e26372af964c49b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Pershing Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1720 Peachtree St NE Unit 333, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4fdf-7676-b730-d6fbb7727063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4fdf-7676-b730-d6fbb7727063",
        "storage_key": "property/6767906449167739/01a03e5c-4fdf-7676-b730-d6fbb7727063.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15821385347496745285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pershing-point-park",
      "poi_latitude": "33.7939667",
      "poi_longitude": "-84.387545",
      "poi_miles_from_property": "427 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5m9BFAE9YgRRRkd9CXakNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9c983c14c5dde5c2ee1ee08a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Winn Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "32 Lafayette Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "This 10-acre, tree-filled park features a playground, benches, a pond & a grassy open area.",
      "poi_long_description": "This 10-acre, tree-filled park features a playground, benches, a pond & a grassy open area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-4f8f-770b-a4c2-000de9ad3da3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-4f8f-770b-a4c2-000de9ad3da3",
        "storage_key": "property/6767906449167739/01a03e5c-4f8f-770b-a4c2-000de9ad3da3.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9197740500695051926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winn-park",
      "poi_latitude": "33.7904879",
      "poi_longitude": "-84.3801603",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcvvBkYE9YgRlu4m8EDwpH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0465aec0e396cb3cb83b8ad7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 Cherokee Ave SE, Atlanta, GA 30315, USA",
      "poi_short_description": "Sprawling green space & recreational area is the heart of one of Atlanta's oldest neighborhoods.",
      "poi_long_description": "Sprawling green space & recreational area is the heart of one of Atlanta's oldest neighborhoods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-7051-702f-89e2-96057a8b87e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7051-702f-89e2-96057a8b87e3",
        "storage_key": "property/6767906449167739/01a03e5c-7051-702f-89e2-96057a8b87e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gpconservancy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3593612641965478544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grant-park",
      "poi_latitude": "33.735704",
      "poi_longitude": "-84.371164",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-521-0938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWeQDuoD9YgRkJK0eKgT3zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_a535991de42064eda8b19d75",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Yonah Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Lafayette Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5162293316480316072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yonah-park",
      "poi_latitude": "33.78894450000001",
      "poi_longitude": "-84.38065309999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV1EUE9YgRqLIum2smpEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_211c6627a682fb8b7e8fca73",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Centennial Olympic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30313, USA",
      "poi_short_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_long_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-4a0a-715c-932b-61798ad704f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-4a0a-715c-932b-61798ad704f3",
        "storage_key": "property/6767906449167739/01a03e59-4a0a-715c-932b-61798ad704f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwcca.org/centennial-olympic-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6004367012448251227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-olympic-park",
      "poi_latitude": "33.760463",
      "poi_longitude": "-84.3930831",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-223-4412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a03-7724-a883-cfddddc7947a",
        "storage_key": "property/6767906449167739/01a03e5a-9a03-7724-a883-cfddddc7947a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRYhpn8E9YgRWy0NPvzLU1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b6f9500130d425fe6347b491",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Arts Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-6cc5-754f-adc7-71ea40552c34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-6cc5-754f-adc7-71ea40552c34",
        "storage_key": "property/6767906449167739/01a03e59-6cc5-754f-adc7-71ea40552c34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.itsmarta.com/Arts-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693853067366476356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-center",
      "poi_latitude": "33.78918",
      "poi_longitude": "-84.38727999999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XSS4FoE9YgRRKoJM-ZX5Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_b082e7854a234f312ec9cf7e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Midtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-8f11-70ae-a8b8-f7ca38998d76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5a-8f11-70ae-a8b8-f7ca38998d76",
        "storage_key": "property/6767906449167739/01a03e5a-8f11-70ae-a8b8-f7ca38998d76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Midtown.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874113686536918320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown",
      "poi_latitude": "33.78107",
      "poi_longitude": "-84.38632",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdym9WF0E9YgRMBWDOd-dwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_e91efae4b4d28b5c75b4ee86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "North Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "713 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-5c04-7318-bb3a-a7e21612bc74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-5c04-7318-bb3a-a7e21612bc74",
        "storage_key": "property/6767906449167739/01a03e59-5c04-7318-bb3a-a7e21612bc74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/North-Ave.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649073214810790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ave",
      "poi_latitude": "33.77179",
      "poi_longitude": "-84.38709",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu65s0W4E9YgR1ZlcTtxARlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_20bb44493d3f92bba6a8b410",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "MARTA",
      "poi_type": "Transportation & Transit",
      "poi_address": "435 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-6746-7118-ae55-99d157b8414d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6746-7118-ae55-99d157b8414d",
        "storage_key": "property/6767906449167739/01a03e5c-6746-7118-ae55-99d157b8414d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.itsmarta.com/Civic-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228538802453485156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marta",
      "poi_latitude": "33.7666055",
      "poi_longitude": "-84.38734939999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6tOQ3oE9YgRZBYyF6PJrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_14b01d75b99eec20c8cd7eec",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Peachtree Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "216 Peachtree Rd NE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-6392-7526-be08-847a77508a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6392-7526-be08-847a77508a6a",
        "storage_key": "property/6767906449167739/01a03e5c-6392-7526-be08-847a77508a6a.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://itsmarta.com/Peachtree-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=968778342906516042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-center",
      "poi_latitude": "33.7580702",
      "poi_longitude": "-84.38739059999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RLXaHgE9YgRStIII8XKcQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_40587bcd367cde9e918be3eb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Five Points MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 Alabama St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-8447-742f-a61c-f4aeef6377d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8447-742f-a61c-f4aeef6377d3",
        "storage_key": "property/6767906449167739/01a03e5c-8447-742f-a61c-f4aeef6377d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456548135659215659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-points-marta-station",
      "poi_latitude": "33.7539909",
      "poi_longitude": "-84.391697",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV048YwAJ9YgRK5tZK21oPIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_627d9fe08b34080c6ab4a9d7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Lindbergh Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2424 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-61cc-71f9-9d9e-bb2f52e44467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-61cc-71f9-9d9e-bb2f52e44467",
        "storage_key": "property/6767906449167739/01a03e59-61cc-71f9-9d9e-bb2f52e44467.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Lindbergh.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=632507744447004235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindbergh-center",
      "poi_latitude": "33.8231157",
      "poi_longitude": "-84.36943869999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9e5a-7069-899f-bd3689e4229a",
        "storage_key": "property/6767906449167739/01a03e5a-9e5a-7069-899f-bd3689e4229a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8oZEMIF9YgRS35yQXEexwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_e0824950b8b105d2dd2da9d8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Atlanta, Georgia",
      "poi_type": "Transportation & Transit",
      "poi_address": "1688 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-8503-7760-a661-e132799ded5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8503-7760-a661-e132799ded5c",
        "storage_key": "property/6767906449167739/01a03e5c-8503-7760-a661-e132799ded5c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ATL",
      "poi_directions_map_url": "https://maps.google.com/?cid=8455012273152189261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-georgia",
      "poi_latitude": "33.7994122",
      "poi_longitude": "-84.39260329999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9d52-7231-9828-c572d6d85311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9d52-7231-9828-c572d6d85311",
        "storage_key": "property/6767906449167739/01a03e5c-9d52-7231-9828-c572d6d85311.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJFybLXVQE9YgRTePNqN08VnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_18856e9c42eaab7a8c880e8d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-6f89-721e-a2dc-862de6945e56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-6f89-721e-a2dc-862de6945e56",
        "storage_key": "property/6767906449167739/01a03e5c-6f89-721e-a2dc-862de6945e56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9d2b-7440-9481-9d25339fb9be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9d2b-7440-9481-9d25339fb9be",
        "storage_key": "property/6767906449167739/01a03e5c-9d2b-7440-9481-9d25339fb9be.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_c7621fe40bd5f331f38917cb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Georgia Tech Research Institute",
      "poi_type": "Education",
      "poi_address": "250 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gtri.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12881642788148951996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-tech-research-institute",
      "poi_latitude": "33.7857606",
      "poi_longitude": "-84.394909",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-407-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd_KISIsE9YgRvDsXr93JxLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_30fd82046bd87c4c5f6a33ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Federal Reserve Bank of Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-7043-748c-9a92-abe3ea8a0dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7043-748c-9a92-abe3ea8a0dcc",
        "storage_key": "property/6767906449167739/01a03e5c-7043-748c-9a92-abe3ea8a0dcc.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.atlantafed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811497039753145462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-atlanta",
      "poi_latitude": "33.782425",
      "poi_longitude": "-84.3847892",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-498-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9d56-771f-8d17-4fdd134cb386.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9d56-771f-8d17-4fdd134cb386",
        "storage_key": "property/6767906449167739/01a03e5c-9d56-771f-8d17-4fdd134cb386.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_yk6kIE9YgRdmysoEYnCpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_4a0b028f611df82b97e31980",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e58-f102-7490-9808-6cd4aef9bf7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e58-f102-7490-9808-6cd4aef9bf7e",
        "storage_key": "property/6767906449167739/01a03e58-f102-7490-9808-6cd4aef9bf7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9a01-75df-a553-cd24e9b56ffc",
        "storage_key": "property/6767906449167739/01a03e5a-9a01-75df-a553-cd24e9b56ffc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_be66a6bd6694bed1953d9f41",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "One Coca-Cola Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "528 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-8c8c-7666-b4aa-f8413f9cd5f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-8c8c-7666-b4aa-f8413f9cd5f4",
        "storage_key": "property/6767906449167739/01a03e59-8c8c-7666-b4aa-f8413f9cd5f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coca-colacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947067275745438064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-coca-cola-plaza",
      "poi_latitude": "33.7711478",
      "poi_longitude": "-84.397268",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-676-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ISQokD9YgRcCnkPRc5rbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_7e20217ef3b8e879e0491f1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Grady Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "80 Jesse Hill Jr Dr SE, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e59-3575-7377-90c0-dd2227c6a5eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e59-3575-7377-90c0-dd2227c6a5eb",
        "storage_key": "property/6767906449167739/01a03e59-3575-7377-90c0-dd2227c6a5eb.webp",
        "width": 1200,
        "height": 400
      },
      "poi_business_url": "https://www.gradyhealth.org/?utm_source=gmb&utm_medium=organic&utm_campaign=sitelink&utm_id=grady",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804908829099084763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grady-memorial-hospital",
      "poi_latitude": "33.7517861",
      "poi_longitude": "-84.3820111",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-616-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9ab5-71be-bf88-031d89515c22",
        "storage_key": "property/6767906449167739/01a03e5a-9ab5-71be-bf88-031d89515c22.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Rc8z44D9YgR28vCVjqbUGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0ca667485e96ab0c137c0a96",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta - Egleston Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1405 Clifton Rd NE, Atlanta, GA 30322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-7ae0-764c-9096-c74979f41660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-7ae0-764c-9096-c74979f41660",
        "storage_key": "property/6767906449167739/01a03e5c-7ae0-764c-9096-c74979f41660.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.choa.org/locations/egleston-hospital?cid=_na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=10949268201800251684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta---egleston-hospital",
      "poi_latitude": "33.7934917",
      "poi_longitude": "-84.3195325",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5a-9abb-74c9-bf77-f35f4e598de9",
        "storage_key": "property/6767906449167739/01a03e5a-9abb-74c9-bf77-f35f4e598de9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4J4LPoG9YgRJLnI9mqd85c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_0bda37db44a3cd8fb787c29c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "poi_name": "Centers for Disease Control and Prevention",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Clifton Rd NE, Atlanta, GA 30333, USA",
      "poi_short_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_long_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-8b50-733f-b415-4a13c21c04d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03e5c-8b50-733f-b415-4a13c21c04d9",
        "storage_key": "property/6767906449167739/01a03e5c-8b50-733f-b415-4a13c21c04d9.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://www.cdc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310566027616466354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centers-for-disease-control-and-prevention",
      "poi_latitude": "33.799329",
      "poi_longitude": "-84.32858999999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-639-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167739/01a03e5c-9d56-771f-8d17-4fdd134cb386.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03e5c-9d56-771f-8d17-4fdd134cb386",
        "storage_key": "property/6767906449167739/01a03e5c-9d56-771f-8d17-4fdd134cb386.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsx8GO3oE9YgRsjXGwtsQMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5b3af221f82f2f9332c68f25",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7c911e7228e9c2d37cdb3cab",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_440be97c807abee82c9f517d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_04e13ad1bca605253efeea5b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_64834e7146c4fc266bdafe0d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_22410cd12fb2866404f2db9b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_77ce2c401dcdf7238114176e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Very pleased. Everyone seems to go out of their way to make a living here an outstanding experience",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4c67ee865923e569426ba72c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Great place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_27eb50c6499f1254b79a3c1d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "it is great",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_8287853a8c30df53a844015c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "It's almost like living at a resort, makes my life much easier with it's location, very helpful staff and great amenities.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_8feb82b8e96589c7d04c14ba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a fantastic building. The staff is extremely attentive and very competent. The building feels very safe, and the other residents are all extremely polite. Highly recommend.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7ea20fd02bf66ee9bafd93e5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I moved to Ascent a couple of months ago, I was one of the first residents to move in. There were some slight issues in the unit, which is normal for a brand new building. However anytime I reported a problem, the management took care of it immediately. Im really amazed by the staff working at the building; and I mean everyone, from sales, to receptionists, to cleaning personnel, maintenance and the management; the entire team is very friendly and care a great deal for the residents. I was moving from Miami, the first two months I wasnt much at the building because my wife was still back in Miami. Last week she finally moved to Atlanta and the first thing she got when we stepped in the building was a bottle of wine and a birthday card from the management and admin staff. They knew it had been her birthday few days ago and had prepared this nice surprise for her. My wife was overwhelmed by the kindness of the people and she felt welcomed and more importantly, she felt at home already from day one.  I also like the people living in the building; it seems that they do put quality over sales volume and I find it very important. I know the screening process is rigorous because I had to go through it as well. I hope they continue to keep the high standards, this will definitively differentiate Ascent from the several options available in the area. Congratulations to the staff and a big thank you for making us feel truly at home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d5d45d2622d085423400ef16",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Nicholas did a fantastic job showing me around and responding quickly to my questions/requests.  The amenities here are wild and everything is finished beautifully.  So all in all, between the service and the actually living space, this was the obvious choice to make when deciding what high rise to live in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d3750be6a6c9777623d410fe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Excellent office and facility team. Beautiful building with great features. Great location.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_352aed6a47c6cc14adc7e3f9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I love living at Ascent Midtown! The staff is awesome and the community is beautiful. 10 out of 10!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9dfa959168151a4faeb5d43d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "So glad we made the choice to move to Ascent. Our apartment is bright and sunny and a perfect floor plan. The staff and building are excellent.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7d27390eb88a19d6f583d901",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "The team here has been above and beyond helpful with everything since I moved in making it really feel like home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a5348b18d2daed1f1a286a33",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "My dog and I love Ascent! We love living in this part of town, and our unit, amenities, and building in general are beautiful. The employees here are friendly and welcoming, and they are always so sweet to my dog. He's a very timid boy but living here has helped him learn to love people!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_46b308b6d0da059873278931",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has an excellent location in Midtown where I can walk to work, to Whole Foods, and so much entertainment. Piedmont Park is only a few minutes walk. The interior finishes and high end appliances make my home impressive and yet very functional. Google Fiber is an option that I was looking for and makes working from home during this unprecedented time easy and without interruption. The concierge is amazing, they make the entire experience enjoyable and convenient with all services, alongside the management and maintenance team members! All needs are handled with a smile and patience. I truly just love it here!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_31cbf76ad6eac7bf8f10939a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "High quality apartment complex with great staff and amenities!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_88737860c35198df08b12077",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Thanks to the professionalism of Ascent Midtown Apartments, my leasing experience and move were quick and easy. Special thanks to Nicholas, Irina and Jonathan who went out of their way to assist me and to ensure that I have everything I need.  They have exceeded my expectations. I am so happy with my Ascent apartment, the extraordinary amenities and beautiful views.  I am truly enjoying living at Ascent and having access to all that Midtown offers.  I highly recommend living here!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_a5e19b251e590deab2cba7e7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "This is a good place to live",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b22b0e8e5ea671124cdbbcaa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "This building is everything you can imagine plus more the staff is amazing, the amenities is amazing my apartment is very cozy and fit for me I love everything about it",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_80060a933a8ad5b101d9df3b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "This is my first time living in a city community and coming home to ascent is the best part of my day",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_da9d303fb54153a49c681300",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Finding the perfect apartment in Atlanta is hard, but Im so glad I chose Ascent Midtown! Living here has been the best experience ever, from my tour to move in, Ive had a cohesive and luxury experience. Ascent Midtown has done an exceptional job of providing their residents with a great experience, given the current circumstances of the pandemic, theyve done a great hob with keeping the community safe, clean and still enjoyable",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_ee62ce0afb48ec0ca5ed4153",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Love living at Ascent midtown. Great location, management/concierge and clean apartment including amenities.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2cc5d46e60b14c4ec103c704",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Helpful staff, good facilities and safe environment. Pleased I chose this place!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_faad8082e9993de1b3e1cf04",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I moved in a couple of weeks ago and have had a great experience. The facilities work well as intended. But, it’s the people working here that make this place very special. For example, Korhan, the maintenance supervisor was extremely helpful when I wanted his assistance with setting up my TV in my apartment. He was prompt, helpful and very kind. Bryanna in the concierge has also been extremely helpful. She does her best to assist the residents with their requirements. She is very prompt and understanding. Jacky and Angelica in the concierge are also very efficient and supportive.\nOverall, I feel justified in my decision in choosing Ascent Midtown. Great facilities, and even better people.",
      "date": "false",
      "title": "Great People Great Facilities"
    },
    {
      "id": "ec_c0fca0cb79b41c3a8f26a85d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "One of the nicest apartments in Midtown, with beautiful luxury amenities and helpful staff.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d70619542065b8ef6e655db6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Having lived in various communities in Emory and Midtown Atlanta area this community feels the safest and best kept of any we have been in or visited.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fe2622ada8a50681ed24f9bc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "I have only been living at Ascent for a couple of weeks and I'm already in love! The view is EVERYTHING! I am enjoying all of the amenities as well as the monthly happenings/events that are held in the Ascent community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c26d98587a9e30cd37fca93d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Ascent midtown is a wonderful place to live. The employees are friendly, efficient, and classy. I have never encountered an issue living here that is worth mentioning. The amenities are great, they host events which are very fun and allow you to meet your neighbors, the elevators are super fast, the appliances are modern, and the maintenance is timely and efficient. I have nothing bad to say about this place.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4d205459d657957d8a66b9bd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "It is a great walking community.  The property and the views are simply amazing.  I love the rooftop to go read and just enjoy the view of the city.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bf1c4dee5bd84c38997c51a0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Being retired military I have moved quite a bit and I must say the staff at Ascent Midtown is possibly the best and most accommodating Ive come in contact with. My experience from the day I did my tour of the property to date has been nothing less of exceptional. The professionalism of the staff in the Leasing Office is top notch in particularly Manny. I pray Im spelling his name correctlybut he goes above and beyond to ensure that the residents are being taken care of and have everything they need. Even though he sits in the leasing office he will get up from his desk to grab a package; hold a door; help you on the elevator or just to say hi. And he does it all with a smile. The other day, while standing in the lobby, I heard some other residence speaking of his kindness. Hes absolutely amazing!! Along with all the other staff. The building and its amenities give a resort style living experience. Its a very clean and inviting environment. I will and have recommended Ascent Midtown to friends and family looking to move to the area.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4ced3f16246de4eaca889c47",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "This apartment goes above and beyond when it comes to quality. They don't cut any corners when it comes to appliances or amenities. I love it here - and the concierge and leasing office folks are SO kind and helpful!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_095770f59c85574b4cab357d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Kind and professional staffs. All areas are clean. Easy to get Marta station by walk.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_bab347633d354b1af239c955",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is an amazing place to stay!! The leasing office staff was incredibly nice and knowledgeable. Tamika, Jordan, Manny, Huan, and Johnathon are all amazing and played a vital role in getting me situated.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_324bf0c115981645df61a6af",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I love it here. Best views, top-tier amenities, and great concierge!!!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9b5c6957b8b76f8f9fb78470",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Fell in love with the property the first time I saw it. The amenities are everything. Also, everyone from the office staff to the maintenance crew have been nothing but helpful and friendly. Overall a great experience since I moved in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_cd5291c76b3d9ada2b5daef9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent is a place where people from different backgrounds, cultures and nationalities live and make a beautiful and respectful community. The community events makes it fun to meet our neighbors and be part of the community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_d70248467e7d847d9ddc0717",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Staff is so helpful and friendly. Quiet area, good neighbors as well.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_015a2b9f561f3f5d70704076",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a safe and secure property that is perfect for those looking for a luxurious residential experience. The amenities are amazing, the staff are pleasant and great at their roles, especially Jacob who is an excellent leasing agent, and the community feels like family. I would highly recommend Ascent Midtown to anyone looking for a new place to call home.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b94a288022f6d4e22ee6b3c5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Jacob has been extremely accommodating. Quality apartment and great amenities",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3cdddded6756e3bf1fb2745a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has made our move to our dream city a dream in itself. We love working with the lovely staff and have enjoyed our time living in the community.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3e9cf4acd57b5cb106817f5e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is amazing and the management is very understanding and communicative. They definitely bring the community together.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_738295ff44e4e9c407c5671d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is a very clean, safe, and comfortable !",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_19564aa0e0f1119e1258e6f5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Ascent so far is a really nice apartment besides the exception of having only four elevators only on the third/fourth floor in the parking garage but other than that the amenities are really nice , the view is gorgeous, good location it’s right next to everything you need , and its quiet in the apartment no loud noise at all . Which is very soothing to be in .",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_071fa8f6f361ccf793ab7f7e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Ascent is a beautiful community with amazing amenities and staff. I love the community gatherings that are held monthly so we can get to know our neighbors.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fa3bc7e57c3aa12ecd805d70",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Located in the city center, there are many facilities nearby and it is very convenient. Also, the inside of the house is very tidy and satisfactory. I think it was a very good choice to live here.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_2d582ec7bf744f7981fbabe4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "The leasing office and concierge service along with maintenance are excellent at what they do the hospitality and punctual ability they display are next level but the residents are the best reason for staying at the ascent they speak and are very friendly",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_956b94f219ff945f7661b559",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown is high-quality living in a wonderful location. The amenities are top-notch and the staff are welcoming and helpful. I would recommend to my family and friends!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_38cf15efdeb9be82d96d414b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "Ascent is my first ever apartment on my own. I can honestly say I made the PERFECT choice. Absolutely love my 887 sq. foot apartment that sits right over the midtown area. Best apartment complex the city has to offer.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_4e656d0af84a4ce1d44e7df3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "This apartment has many great amenities and features.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c9cfa57c939013d2fcb3fea3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "The amenities are excellent and the location is good, so I am very satisfied. Additionally, events for residents are held periodically, for which I am very grateful.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fd4d9484b037c9d78098774b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has - so far - exceeded my expectations. I love calling this my home. The amenities, the apartment finishes, the location - it’s all amazing.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_28ed4882049d18a89b2d93d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "If you’re looking for a safe community with excellent management team and superb Maintenance team Ascent midtown  is where to go",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5eceb00fe2cbc421c3c1bf46",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "4",
      "name": "false",
      "text": "I really feel at home at this property. The staff feels like family and I love the design of my unit.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5ba18b1f07ccc2f0aff37162",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has been wonderful so far during our first month of residence. The move-in process was smooth and the vibe is warm and welcoming. Taye and Tameka have been especially awesome!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_3c1a317d92a0803aa3050a26",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "First time living in Atlanta. So glad I picked this place. The staff here is absolutely excellent!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_c44748913a3ff8e135ef7485",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I truly enjoy my living experience at Ascent Midtown. The concierge team is incredibly helpful, always going above and beyond to assist residents. The property is exceptionally well kept—clean, well-maintained, and it always smells fresh and inviting.\n\nI'm also grateful for the concessions I’ve received, which have made my time here even more enjoyable and stress-free. The location is unbeatable, with easy access to so many great shops and restaurants just steps away.\n\nThe amenities are beautiful and thoughtfully designed, adding real value to daily living. Overall, I’m very glad to call Ascent Midtown home!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_fb987172775f46a771ed1126",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Great community to live in! Jason and his team always go above and beyond. My maintenance request are always handled in a timely manner, and if there’s a reason it’s not handled in the first visit, they always keep me updated on the status",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_5b59072aa32a38bddba3f450",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "My issues are a always addressed fast and efficiently.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b9822c87eebf037f06af5d3f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "I love my place here. The team Diego, Z, and Taye are amazing. Concierge is accommodating. The mini market is convenient. The location is nearby everything. The building is clean, smells good, and in great condition. The maintenance guys Jon and Jeremy are knowledgeable and responsive. 10 out of 10.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6f0f10771e1d2b4eb802bc6d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Living at Ascent Midtown has been a seamless experience. The space feels intentional — from the design of the amenities to the overall energy of the community. It’s both refined and comfortable, creating a lifestyle that feels curated rather than just lived in. The team is attentive, and that consistency shows.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_43cea4186674961455547fb5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "Ascent Midtown has definitely been one of my favorite places to live. I love large windows, floor to ceiling windows, and a nice view. This building has some of the best views in the city. The amenities are so beautiful & makes you feel like you’re living in a luxury magazine. From the pool cabanas, to the stunning rooftop, to the beautiful apartments. Truly one of the best buildings in Atlanta!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_7af0715090cecd5398a08377",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "rating": "5",
      "name": "false",
      "text": "The pool is beautiful, staff is friendly, and apartments are elegant. After looking at multiple properties I’m glad I found this place.",
      "date": "false",
      "title": "Verified Renter"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-in-unit-laundry-midtown",
      "search_query": "apartments with in-unit laundry midtown atlanta",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry in Midtown Atlanta",
      "h2_subtitle": "Experience the convenience of apartments with in-unit laundry in Midtown Atlanta. Enjoy modern living at Rise with exceptional amenities.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Rise in Midtown Atlanta, where every apartment features in-unit laundry facilities. Our residences are designed with modern living in mind, offering spacious studio, one, and two-bedroom layouts that cater to your urban lifestyle. Enjoy the luxury of handling laundry from the comfort of your own home, making everyday living easier and more efficient.\n\nRise is more than just a place to live; it’s a community that embraces Atlanta’s vibrant city life. With our prime location in Midtown, you’ll have walkable access to the best dining, shopping, and entertainment that the city has to offer. Relax on our 7th-floor terrace, complete with a luxe pool and custom cabanas, or savor the chic atmosphere of our elegant high-rise living. Explore more at Rise and elevate your Atlanta experience with our in-unit laundry-equipped apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Midtown Atlanta",
      "seo_description": "Find apartments with in-unit laundry in Midtown Atlanta at Rise, featuring modern amenities and a prime location for urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-luxury-apartments-air-conditioning-atlanta",
      "search_query": "luxury apartments with air conditioning atlanta ga",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with A/C in Atlanta, GA",
      "h2_subtitle": "Live comfortably in luxury apartments with air conditioning in Atlanta, GA. Experience upscale urban living at Rise.",
      "page_copy": "Discover luxury living at its finest at Rise, where every apartment is equipped with air conditioning to keep you comfortable year-round in Atlanta, GA. Our upscale high-rise offers extraordinary residences, from studio to two-bedroom layouts, perfect for those seeking a blend of style and comfort. Our air-conditioned homes feature modern interiors and exceptional finishes, providing you with the ultimate living experience.\n\nLocated in the vibrant neighborhood of Midtown Atlanta, Rise provides unparalleled access to the city's bustling energy. Residents indulge in premium amenities like our 7th-floor terrace with a luxe pool, custom cabanas, and scenic views of the city skyline. Elevate your lifestyle in our luxurious apartments that redefine modern urban living, ensuring comfort and convenience at every turn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with A/C in Atlanta, GA",
      "seo_description": "Explore luxury apartments with air conditioning in Atlanta, GA at Rise. Enjoy superior comfort and upscale amenities in Midtown's prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-dedicated-parking-midtown-atlanta",
      "search_query": "apartments with dedicated parking midtown atlanta",
      "category": "Amenity",
      "h1_title": "Apartments with Parking in Midtown Atlanta",
      "h2_subtitle": "Enjoy convenient living at Rise, offering apartments with dedicated parking in Midtown Atlanta. Embrace urban life with ease and comfort.",
      "page_copy": "At Rise, we offer the perfect solution for urban living with our apartments featuring dedicated parking in Midtown Atlanta. Our modern high-rise not only provides chic and stylish residences, but also ensures you have a secure place for your vehicle. This convenience allows you to immerse yourself fully in the vibrant city life without the stress of finding a reliable parking spot.\n\nLocated in the heart of Midtown Atlanta, Rise combines the best of city living with thoughtful amenities. Residents can take advantage of the luxe 7th-floor terrace, complete with a pool and custom cabanas, and walkable access to Atlanta’s thriving dining and entertainment scenes. Whether you're seeking a studio or a two-bedroom apartment, Rise delivers exceptional service and modern comforts, making it the ideal choice for those who value both convenience and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Parking in Midtown Atlanta",
      "seo_description": "Discover apartments with dedicated parking in Midtown Atlanta at Rise. Enjoy convenient and modern urban living with secure parking options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-dishwasher-fulton-county",
      "search_query": "apartments with dishwasher fulton county",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Fulton County",
      "h2_subtitle": "Explore modern living at Rise, where every apartment includes a dishwasher. Discover comfort and convenience in Fulton County.",
      "page_copy": "Rise offers modern urban living with the added convenience of apartments equipped with dishwashers, located right in the heart of Fulton County. Our high-rise residences are designed for contemporary living, featuring studio to two-bedroom floor plans that cater to your lifestyle needs. With a dishwasher in every unit, enjoy more time relaxing and less time on chores.\n\nPositioned in Midtown Atlanta, within bustling Fulton County, Rise provides residents with an urban sanctuary filled with premium amenities. Lounge on our 7th-floor terrace, or take a dip in the luxe pool surrounded by custom cabanas. Experience everyday luxury with gas stoves, ceiling fans, and both vinyl plank and real wood flooring options available in our penthouses. Discover a community that complements your lifestyle and elevates your living experience at Rise.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in Fulton County",
      "seo_description": "Find apartments with dishwashers in Fulton County at Rise. Enjoy modern amenities and stylish living in a prime Midtown Atlanta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-pet-friendly-apartments-dog-park-atlanta",
      "search_query": "pet-friendly apartments with dog park atlanta",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park in Atlanta",
      "h2_subtitle": "Rise offers pet-friendly apartments with a dedicated dog park in Atlanta. Bring your furry friend to our welcoming community.",
      "page_copy": "Welcome to Rise, where pets are as cherished as their owners. Our pet-friendly apartments feature a dedicated dog park, providing a playful retreat for your furry companions in the heart of Atlanta. Whether you're in a studio or a spacious two-bedroom residence, you'll find that living at Rise means both you and your pet have access to modern comforts and ample outdoor spaces.\n\nNestled in Midtown Atlanta, Rise combines urban living with thoughtful amenities designed for pets and their owners. Enjoy the ease of walkable access to local eateries and entertainment, paired with the convenience of our luxe 7th-floor terrace, swimming pool with custom cabanas, and well-designed interiors with gas stoves and ceiling fans. Accommodating your lifestyle and your pet's needs, Rise stands out as the premier choice for pet-friendly living in the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park in Atlanta",
      "seo_description": "Discover pet-friendly apartments with a dog park in Atlanta at Rise. Enjoy a vibrant community with modern amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-studio-apartments-midtown-atlanta",
      "search_query": "studio apartments midtown atlanta",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Midtown Atlanta",
      "h2_subtitle": "Explore studio apartments at Rise, located in vibrant Midtown Atlanta. Enjoy chic urban living with unparalleled amenities.",
      "page_copy": "Discover the perfect blend of style and convenience at Rise, where our studio apartments in Midtown Atlanta offer an ideal urban retreat. Our thoughtfully designed studios provide modern living spaces with features like gas stoves and ceiling fans, ensuring comfort and functionality. Whether you're a professional seeking a dynamic city life or a student wanting proximity to urban excitement, Rise is your go-to choice.\n\nSituated in lively Midtown Atlanta, Rise offers more than just a home. It presents a lifestyle, with amenities like the luxe 7th-floor terrace with a pool and custom cabanas, adding a touch of luxury to your everyday life. With easy access to Atlanta's vibrant cultural and dining hubs, living at Rise means you're perfectly positioned to enjoy the best that the city has to offer while experiencing a cozy urban sanctuary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Midtown Atlanta",
      "seo_description": "Find stylish studio apartments in Midtown Atlanta at Rise. Enjoy modern amenities and vibrant city living in an upscale high-rise.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-1-bedroom-high-rise-atlanta",
      "search_query": "1 bedroom high-rise atlanta",
      "category": "Floorplan",
      "h1_title": "1 Bedroom High-Rise in Atlanta",
      "h2_subtitle": "Discover the ultimate in high-rise living with our 1 bedroom apartments at Rise, centrally located in Atlanta's vibrant scene.",
      "page_copy": "Explore life above the skyline in a 1 bedroom high-rise apartment at Rise, where luxury and convenience converge in Atlanta. These one-bedroom residences offer spacious layouts with modern touches, including gas stoves and ceiling fans, designed for your comfort. The unparalleled views and stylish interiors provide an elevated experience perfect for professionals and couples alike.\n\nLocated in energetic Midtown Atlanta, Rise combines the excitement of city living with tranquility. Enjoy the premium amenities such as the expansive 7th-floor terrace with a pool and custom cabanas, creating an urban oasis in the heart of the city. Step outside and experience the vibrancy of Midtown, filled with dining, shopping, and entertainment options. At Rise, your perfect high-rise living experience awaits in the center of it all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom High-Rise in Atlanta",
      "seo_description": "Experience luxury in a 1 bedroom high-rise apartment at Rise in Atlanta. Enjoy stunning views and modern amenities in the heart of Midtown.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-2-bedroom-luxury-apartments-fulton-county",
      "search_query": "2 bedroom luxury apartments fulton county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Luxury Apartments in Fulton County",
      "h2_subtitle": "Experience refined living in our 2 bedroom luxury apartments at Rise, nestled right in the heart of Fulton County.",
      "page_copy": "Indulge in upscale living with our 2 bedroom luxury apartments at Rise, situated in the vibrant Midtown area of Fulton County. These residences offer an elegant mix of comfort and style, featuring premium finishes such as vinyl plank or real wood flooring, gas stoves, and ceiling fans. Perfect for families or individuals who appreciate spacious and sophisticated design, these apartments are tailored to meet high standards of luxury.\n\nLocated in the pulse of Fulton County, Rise not only offers you a stunning home but also an enriching lifestyle. Our community amenities, like the luxe 7th-floor terrace with a pool and custom cabanas, cater to leisure and relaxation. Just outside your door, Midtown Atlanta awaits with its lively cultural, dining, and entertainment scenes. Embrace the best of Fulton County at Rise, where every detail is designed with luxury in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Luxury Apartments in Fulton County",
      "seo_description": "Explore 2 bedroom luxury apartments at Rise in Fulton County. Experience high-end living with beautiful amenities and a vibrant Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-georgia-tech-atlanta",
      "search_query": "apartments near georgia institute of technology atlanta",
      "category": "School",
      "h1_title": "Apartments Near Georgia Tech Atlanta",
      "h2_subtitle": "Explore modern living at Rise, offering apartments near Georgia Institute of Technology in Atlanta, ideal for students and professionals.",
      "page_copy": "Discover the ideal living situation for students and professionals alike at Rise, offering exceptional apartments near Georgia Institute of Technology in Atlanta. Our luxurious residences provide the perfect blend of comfort and convenience, featuring chic amenities such as gas stoves and ceiling fans in each apartment. Whether you're aiming for a quick commute or looking for an elegant home base close to campus, Rise delivers the perfect environment.\n\nSituated in Midtown Atlanta, Rise is more than just a place to live––it's a thriving community. Experience our stunning 7th-floor terrace complete with a pool and custom cabanas, providing you with spots to relax and unwind. With Midtown's vibrant cultural and academic life at your fingertips, and Georgia Tech just a short walk away, Rise offers the complete Atlanta lifestyle balanced with the peace of a premier residence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Tech Atlanta",
      "seo_description": "Find luxurious apartments near Georgia Tech in Atlanta at Rise. Perfectly located in Midtown, offering modern amenities and lifestyle convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-emory-university-apartments-midtown-atlanta",
      "search_query": "emory university apartments midtown atlanta",
      "category": "School",
      "h1_title": "Emory University Apartments Midtown Atlanta",
      "h2_subtitle": "Discover Rise, the perfect apartments for Emory University students in Midtown Atlanta, offering convenience and upscale living.",
      "page_copy": "Rise offers an exceptional living experience for Emory University students looking for premium apartments in Midtown Atlanta. These beautifully designed residences cater to those seeking a blend of academic convenience and urban adventure. With elegant features like gas stoves, ceiling fans, and options for vinyl plank and real wood flooring, our apartments ensure students and professionals live in style.\n\nLocated within easy reach of Emory University, Rise places you in the heart of Midtown Atlanta, surrounded by vibrant city life and cultural attractions. Enjoy luxurious community amenities like the 7th-floor terrace with a pool and custom cabanas, perfect for relaxation and socializing. Choose Rise for a balanced lifestyle where education, entertainment, and comfort converge seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Emory University Apartments Midtown Atlanta",
      "seo_description": "Explore Rise, offering upscale apartments in Midtown Atlanta perfect for Emory University students, featuring modern amenities and city access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-georgia-state-university-fulton-county-apartments",
      "search_query": "georgia state university fulton county apartments",
      "category": "School",
      "h1_title": "Georgia State University Fulton County Apartments",
      "h2_subtitle": "Live close to Georgia State University in Fulton County at Rise, offering students and professionals modern apartments with top-notch amenities.",
      "page_copy": "For students and professionals connected to Georgia State University, Rise presents ideal Fulton County apartments that provide both convenience and luxury. Our residences are finely crafted with upscale features like gas stoves, ceiling fans, and choices between vinyl plank and real wood flooring, ensuring a high-quality living environment.\n\nNestled in Midtown Atlanta, Rise offers an unmatched lifestyle with easy access to Georgia State University and the bustling energy of Fulton County. Our residents enjoy a luxurious 7th-floor terrace, complete with a pool and custom cabanas, perfect for a study break or afternoon relaxation. Choose Rise for a perfect balance of academic proximity and sophisticated living in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Georgia State University Fulton Apartments",
      "seo_description": "Discover Rise, offering modern Fulton County apartments near Georgia State University with luxurious amenities and prime Atlanta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-close-to-t-deck-atlanta",
      "search_query": "apartments close to t deck atlanta",
      "category": "School",
      "h1_title": "Apartments Close to T Deck Atlanta",
      "h2_subtitle": "Stay at Rise, where our upscale apartments stand close to T Deck in Atlanta, offering easy parking access and luxury living.",
      "page_copy": "Experience premium living at Rise, featuring exceptional apartments close to T Deck in Atlanta. Ideal for those seeking convenience and style, our community offers modern residences equipped with gas stoves, ceiling fans, and a choice of vinyl plank or real wood flooring for your comfort. Whether you're looking for an easy parking solution or a luxurious home, Rise meets your needs perfectly.\n\nSituated in the vibrant atmosphere of Midtown Atlanta, Rise provides the perfect backdrop for a dynamic lifestyle, offering both proximity to T Deck and access to the city's cultural and entertainment venues. Unwind at our 7th-floor terrace with a pool and custom cabanas, creating a relaxing escape from the city's buzz. Choose Rise for iconic architecture combined with practicality, where comfort and accessibility converge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to T Deck Atlanta",
      "seo_description": "Explore Rise for luxurious living near T Deck in Atlanta, offering premium apartments with modern amenities and prime Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-scad-atlanta-apartments-near-30309",
      "search_query": "scad atlanta apartments near 30309",
      "category": "School",
      "h1_title": "SCAD Atlanta Apartments Near 30309",
      "h2_subtitle": "Discover Rise, stylish apartments near SCAD Atlanta in the 30309 area, offering convenience and upscale amenities.",
      "page_copy": "At Rise, we offer creative and dynamic spaces perfect for SCAD Atlanta students, situated conveniently near the 30309 area. Our luxury high-rise apartments are designed with sophisticated features, including gas stoves, ceiling fans, and options between vinyl plank and real wood flooring, ensuring a stylish and comfortable living experience.\n\nLocated in Midtown Atlanta, Rise offers proximity to SCAD Atlanta and provides easy access to the city’s arts and cultural scene. Our residents enjoy exclusive amenities like the 7th-floor terrace, complete with a luxe pool and custom cabanas, ideal for relaxing or socializing with peers. Join Rise and immerse yourself in a community that supports both academic success and artistic inspiration within Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "SCAD Atlanta Apartments Near 30309",
      "seo_description": "Explore Rise, offering SCAD Atlanta apartments near the 30309 area with upscale amenities and a prime location in Midtown Atlanta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-grady-memorial-hospital-atlanta",
      "search_query": "apartments near grady memorial hospital atlanta",
      "category": "Hospital",
      "h1_title": "Apartments Near Grady Memorial Hospital Atlanta",
      "h2_subtitle": "Rise offers luxurious apartments near Grady Memorial Hospital in Atlanta, providing comfort and convenience in Midtown living.",
      "page_copy": "Healthcare professionals and medical students will find an ideal home at Rise, with apartments located conveniently near Grady Memorial Hospital in Atlanta. Our upscale residences boast modern amenities, including gas stoves, ceiling fans, and a selection between vinyl plank and real wood flooring, ensuring a comfortable and stylish environment.\n\nNestled in the vibrant Midtown Atlanta community, Rise presents the perfect blend of proximity to Grady Memorial Hospital and access to the city's urban lifestyle. Residents can relax at our splendid 7th-floor terrace featuring a pool and custom cabanas, offering a tranquil escape just steps from their home. Choose Rise for a balanced lifestyle of convenience and luxury in the heart of Atlanta.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grady Memorial Hospital Atlanta",
      "seo_description": "Find stylish living at Rise, apartments near Grady Memorial Hospital in Atlanta, with luxury amenities and an ideal Midtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-midtown-atlanta-apartments-near-emory-university-hospital",
      "search_query": "midtown atlanta apartments close to emory university hospital midtown",
      "category": "Hospital",
      "h1_title": "Midtown Atlanta Apartments Close to Emory Hospital",
      "h2_subtitle": "Discover luxurious Midtown Atlanta apartments near Emory University Hospital Midtown, offering comfort and convenience at Rise.",
      "page_copy": "Welcome to Rise, where luxury meets proximity. Our high-rise community is located close to Emory University Hospital Midtown, providing an ideal setting for healthcare professionals and students. Enjoy sophisticated residences featuring gas stoves, ceiling fans, and options of vinyl plank or real wood flooring, ensuring a comfortable living experience.\n\nIn the heart of Midtown Atlanta, Rise offers not only closeness to Emory University Hospital but also access to vibrant cultural and lifestyle offerings. Residents can unwind at our stunning 7th-floor terrace, complete with a luxe pool and custom cabanas. At Rise, enjoy the perfect mix of upscale living and everyday convenience within Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Atlanta Apartments Near Emory Hospital",
      "seo_description": "Explore Rise, offering premium Midtown Atlanta apartments near Emory University Hospital Midtown, with luxury amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-atlanta-botanical-garden",
      "search_query": "apartments near atlanta botanical garden",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Embrace nature's beauty with apartments near the Atlanta Botanical Garden at Rise, offering luxury living in Midtown Atlanta.",
      "page_copy": "At Rise, experience urban living with a touch of nature. Our high-rise apartments are perfectly situated near the Atlanta Botanical Garden, ideal for those who cherish green spaces. Enjoy upscale amenities, including gas stoves, ceiling fans, and options of vinyl plank or real wood flooring, catering to a modern lifestyle.\n\nLiving in Midtown Atlanta means the Botanical Garden is just a stroll away, offering a peaceful retreat amidst bustling city life. Residents can also relax at our exquisite 7th-floor terrace with a luxe pool and custom cabanas, enhancing leisure time at home. Choose Rise for a unique blend of city conveniences and natural beauty in a premium Fulton County location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atlanta Botanical Garden",
      "seo_description": "Discover Rise, offering luxurious apartments near the Atlanta Botanical Garden in Midtown Atlanta, with exceptional amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-midtown-atlanta-apartments-near-piedmont-park",
      "search_query": "midtown atlanta apartments close to piedmont park",
      "category": "Park",
      "h1_title": "Midtown Atlanta Apartments Close to Piedmont Park",
      "h2_subtitle": "Find yourself at home in Midtown Atlanta, close to the picturesque Piedmont Park. Live luxuriously at Rise, where comfort meets convenience.",
      "page_copy": "Discover the perfect blend of urban lifestyle and nature at Rise, ideally located close to Piedmont Park in Midtown Atlanta. Our upscale high-rise community offers extraordinary residences, including studio, one, and two-bedroom apartments, designed with modern living in mind. Enjoy amenities such as gas stoves, ceiling fans, and options of vinyl plank or real wood flooring, crafted to elevate your living experience.\n\nPiedmont Park, just minutes from Rise, is a quintessential Atlanta landmark providing lush greenery and recreational opportunities. Residents can also take advantage of our outstanding 7th-floor terrace, featuring a luxury pool and custom cabanas, perfect for relaxation after a day of outdoor fun. Experience vibrant Midtown living at its best, with the park and city's pulse at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Atlanta Apartments Near Piedmont Park",
      "seo_description": "Explore Rise, offering luxurious Midtown Atlanta apartments near Piedmont Park, with premium amenities and an ideal urban location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-centennial-olympic-park-atlanta",
      "search_query": "centennial olympic park nearby apartments atlanta",
      "category": "Park",
      "h1_title": "Centennial Olympic Park Nearby Apartments",
      "h2_subtitle": "Experience the vibrancy of Atlanta with nearby apartments to Centennial Olympic Park. Live comfortably at Rise, offering a blend of luxury and city life.",
      "page_copy": "Rise is your gateway to vibrant city living, located near the iconic Centennial Olympic Park in Atlanta. Our modern high-rise offers a range of luxury apartments, including studios, and one or two-bedroom residences, each featuring gas stoves, ceiling fans, and a choice of vinyl plank or real wood flooring for a bespoke living experience.\n\nBeing close to Centennial Olympic Park means you're steps away from Atlanta's rich history and year-round events. At Rise, enjoy the best of both worlds: city excitement and serene leisure on our stunning 7th-floor terrace, complete with a luxurious pool and custom cabanas. Experience an elevated lifestyle in Midtown Atlanta, where urban energy meets elegant living in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Centennial Olympic Park Atlanta",
      "seo_description": "Find luxurious apartments near Centennial Olympic Park at Rise in Midtown Atlanta, offering premium amenities and a prime city location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-fulton-county-apartments-near-westside-park",
      "search_query": "apartments in fulton county near westside park",
      "category": "Park",
      "h1_title": "Apartments in Fulton County Near Westside Park",
      "h2_subtitle": "Explore Fulton County living with apartments near Westside Park. Rise provides luxury living in the heart of Midtown Atlanta.",
      "page_copy": "Discover the perfect apartment in Fulton County, just a short distance from Westside Park, at Rise. Our modern high-rise offers a sophisticated lifestyle with studio, one, and two-bedroom floor plans, designed with elegance and comfort in mind. Each apartment boasts high-end features like gas stoves, ceiling fans, and a choice of vinyl plank or real wood flooring.\n\nBeing near Westside Park means you can enjoy one of Atlanta's largest green spaces, offering outdoor activities and leisure. After a day at the park, unwind on our luxurious 7th-floor terrace featuring a pool and custom cabanas. Rise offers you the ultimate urban living experience in Midtown Atlanta, combining nature's tranquility with city living in bustling Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fulton County Apartments Near Westside Park",
      "seo_description": "Discover Rise, offering luxurious Fulton County apartments near Westside Park in Midtown Atlanta, with exceptional amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-five-points-atlanta",
      "search_query": "apartments near five points atlanta",
      "category": "Transit",
      "h1_title": "Apartments Near Five Points Atlanta",
      "h2_subtitle": "Enjoy city living with Rise, just moments from Five Points in Atlanta. Discover an upscale lifestyle in our modern high-rise.",
      "page_copy": "Experience urban convenience and modern luxury at Rise, located just a short distance from Five Points in Atlanta. Our high-rise community features beautifully designed studio, one, and two-bedroom apartments, equipped with premium amenities such as gas stoves, ceiling fans, and the option of vinyl plank or real wood flooring.\n\nFive Points, a significant hub of Atlanta, offers easy access to shopping, dining, and entertainment. Meanwhile, at Rise, you can relax in style with our 7th-floor terrace, which includes a stunning pool and custom cabanas. Embrace the best of Midtown Atlanta living—where culture, comfort, and connectivity meet in the heart of the city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Five Points in Atlanta",
      "seo_description": "Find luxurious apartments near Five Points in Atlanta at Rise, featuring premium amenities and a prime Midtown location for ultimate urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-arts-center-midtown",
      "search_query": "apartments close to arts center midtown",
      "category": "Transit",
      "h1_title": "Apartments Close to Arts Center Midtown",
      "h2_subtitle": "Discover the artistic charm of Midtown living with apartments close to the Arts Center. Enjoy upscale amenities and cultural convenience at Rise.",
      "page_copy": "Nestled in the vibrant heart of Midtown, Rise offers premier apartments close to the Arts Center, allowing you to immerse yourself in Atlanta's creative and cultural scene. Our elegant high-rise provides studio, one, and two-bedroom options, each designed with high-quality finishes such as gas stoves, ceiling fans, and a choice between vinyl plank and real wood flooring.\n\nLiving near the Arts Center means you're steps away from galleries, theaters, and dining venues. At Rise, relish in urban sophistication, enjoying leisure on our 7th-floor terrace with a luxurious pool and private cabanas. Embrace urban convenience and style in Midtown Atlanta's thriving arts and nightlife scene, all within bustling Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arts Center in Midtown",
      "seo_description": "Explore Rise's luxurious apartments near Arts Center in Midtown Atlanta, offering premium amenities and an unbeatable cultural location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-north-ave-atlanta-ga",
      "search_query": "apartments near north ave atlanta ga",
      "category": "Transit",
      "h1_title": "Apartments Near North Ave Atlanta, GA",
      "h2_subtitle": "Live in the heart of Atlanta with apartments near North Ave. Rise provides luxurious living in a prime Midtown location.",
      "page_copy": "Conveniently located near North Ave, Atlanta, GA, Rise is the epitome of modern living. Our upscale high-rise offers a distinctive architectural style with a variety of studio, one, and two-bedroom apartments, all featuring high-end amenities such as gas stoves and ceiling fans, with flooring options including vinyl plank and real wood in our penthouses.\n\nBeing close to North Ave means you're just steps away from Atlanta's tech hub, dining, and vibrant social scenes. Unwind at our 7th-floor terrace, complete with a stylish pool and premium cabanas, providing a serene escape in Midtown Atlanta. Experience the essence of luxury and convenience at Rise, perfect for those seeking dynamic city life in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Apartments Near North Ave Atlanta, GA",
      "seo_description": "Discover Rise, offering stylish apartments near North Ave, Atlanta, GA, with luxurious amenities and an ideal Midtown location for urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-near-lindbergh-center-fulton-county",
      "search_query": "apartments near lindbergh center fulton county",
      "category": "Transit",
      "h1_title": "Apartments Near Lindbergh Center Fulton County",
      "h2_subtitle": "Explore luxury living at Rise, conveniently located near Lindbergh Center in Fulton County. Experience high-rise comfort and style.",
      "page_copy": "Rise offers a prime living experience with its proximity to Lindbergh Center in Fulton County. Our community is designed for those who desire modern amenities, having studio, one, and two-bedroom apartments. Each residence is equipped with features like gas stoves, ceiling fans, and the choice between vinyl plank and real wood flooring in select units.\n\nLiving near Lindbergh Center positions you advantageously close to shopping, dining, and major transit lines, enhancing your urban lifestyle in Atlanta. Relax on our exclusive 7th-floor terrace, complete with a luxurious pool and bespoke cabanas, offering a serene escape right in Midtown. If you seek a blend of convenience and upscale amenities, Rise is where you want to be.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Lindbergh Center, GA",
      "seo_description": "Rise offers luxury apartments near Lindbergh Center, Fulton County, with elegant amenities and a strategic Midtown Atlanta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167739",
      "source": "generator",
      "page_item_url": "rise-apartments-close-to-midtown-atlanta-transit",
      "search_query": "apartments close to midtown atlanta transit",
      "category": "Transit",
      "h1_title": "Apartments Close to Midtown Atlanta Transit",
      "h2_subtitle": "Enjoy the ease of living close to Midtown Atlanta transit at Rise. Offering upscale amenities just steps from public transportation.",
      "page_copy": "At Rise, discover the perfect blend of convenience and luxury with our apartments close to Midtown Atlanta transit. Our high-rise community boasts sophisticated studio, one, and two-bedroom residences, each featuring premium gas stoves, ceiling fans, and various flooring options, including vinyl plank and real wood in select penthouses.\n\nLiving near Midtown transit options, you are empowered with seamless connectivity to Atlanta's bustling attractions and business districts. After a busy day exploring the city, unwind on our 7th-floor terrace, home to a chic pool and custom cabanas. With such a strategic location and luxurious amenities, Rise is the ideal choice for those seeking a vibrant urban lifestyle in Fulton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
      "featured_image_media": {
        "alt_text": "Rooftop swimming pool with lounge chairs and city views.",
        "public_id": "01a03e59-6178-77bf-b010-133800fe1b44",
        "storage_key": "property/6767906449167739/01a03e59-6178-77bf-b010-133800fe1b44.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenience at Apartments Close to Midtown Transit",
      "seo_description": "Rise offers convenience with apartments close to Midtown Atlanta transit, featuring luxurious amenities and easy access to public transportation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InFXcE01K2V2RGhycGFFd1o5RmpWcmc9PSIsInZhbHVlIjoicnV5TlhKUVg4L0hBSXJVWlJpTzI3QT09IiwibWFjIjoiOTlmYmE1ZjIzNmJiNmRhNWZjM2YyNjk2NWI1OGZkZjg2ZGJmNDk0MTc4NTE5MjEyMGMyZGFhYzNjMTA1Y2Y0ZSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6InFXcE01K2V2RGhycGFFd1o5RmpWcmc9PSIsInZhbHVlIjoicnV5TlhKUVg4L0hBSXJVWlJpTzI3QT09IiwibWFjIjoiOTlmYmE1ZjIzNmJiNmRhNWZjM2YyNjk2NWI1OGZkZjg2ZGJmNDk0MTc4NTE5MjEyMGMyZGFhYzNjMTA1Y2Y0ZSJ9"
};

export const generatedAt = '2026-08-26T14:38:08.832Z';
